export const ingredientData = [
  // ─── Lanolin Derivatives ───
  {
    name: "Acetylated Lanolin",
    slug: "acetylated-lanolin",
    category: "Lanolin Derivative",
    description:
      "A chemically modified form of lanolin where acetic acid has been added to improve its texture and water resistance.",
    whyUsed:
      "Formulators love it as an emollient because it spreads easily and gives products a silky, luxurious feel on the skin.",
    whyClogsPores:
      "Acetylated lanolin forms a thick occlusive barrier that traps dead skin cells and sebum inside pores. Its heavy molecular structure doesn't absorb well, sitting on top of the skin and creating the perfect environment for comedones to form.",
    commonProducts: ["moisturizers", "lip balms", "foundations", "eye creams"],
    alsoKnownAs: ["Lanolin Acetate"],
  },
  {
    name: "Acetylated Lanolin Alcohol",
    slug: "acetylated-lanolin-alcohol",
    category: "Lanolin Derivative",
    description:
      "The alcohol fraction of lanolin that has been acetylated, making it more compatible with other cosmetic ingredients and less sticky than pure lanolin.",
    whyUsed:
      "It acts as an emollient and skin-conditioning agent that helps stabilize emulsions while adding a smooth, non-greasy feel.",
    whyClogsPores:
      "Like other lanolin derivatives, it creates a heavy occlusive film over pores. This waxy layer prevents natural sebum from flowing freely, leading to buildup and blockages. It ranks high on comedogenicity scales due to its pore-sealing tendency.",
    commonProducts: ["moisturizers", "lipsticks", "hair conditioners"],
    alsoKnownAs: [],
  },
  {
    name: "Ethoxylated Lanolin",
    slug: "ethoxylated-lanolin",
    category: "Lanolin Derivative",
    description:
      "Lanolin that has been processed with ethylene oxide to make it more water-soluble and easier to blend into formulations.",
    whyUsed:
      "It works as both an emulsifier and emollient, helping oil and water mix while leaving skin feeling soft and conditioned.",
    whyClogsPores:
      "Despite being more water-soluble than raw lanolin, ethoxylated lanolin still deposits a pore-blocking residue on skin. Its waxy nature traps oils and dead cells in follicles. Over time this buildup leads to comedones, especially in acne-prone skin.",
    commonProducts: ["lotions", "shampoos", "body washes", "creams"],
    alsoKnownAs: ["PEG Lanolin", "Laneth"],
  },
  {
    name: "Lanolin",
    slug: "lanolin",
    category: "Lanolin Derivative",
    description:
      "A natural wax secreted by the sebaceous glands of sheep, extracted from raw wool. It closely mimics human skin lipids.",
    whyUsed:
      "It's one of the most effective natural emollients around — it can absorb twice its weight in water, making it a go-to for heavy-duty moisturizing.",
    whyClogsPores:
      "Lanolin's thick, waxy consistency creates a dense occlusive seal over pores. While that's great for trapping moisture, it also traps sebum and dead skin cells underneath. It consistently tests as highly comedogenic across dermatological studies.",
    commonProducts: ["lip balms", "nipple creams", "hand creams", "ointments"],
    alsoKnownAs: ["Wool Wax", "Wool Fat", "Adeps Lanae"],
  },
  {
    name: "Lanolin Alcohol",
    slug: "lanolin-alcohol",
    category: "Lanolin Derivative",
    description:
      "The alcohol fraction isolated from lanolin wax, consisting of a complex mixture of sterols and fatty alcohols.",
    whyUsed:
      "It serves as an emulsifier and thickener that helps stabilize creams and lotions while adding emollient properties.",
    whyClogsPores:
      "Lanolin alcohol has a waxy molecular structure that forms an occlusive layer over pores, impeding the natural shedding of dead skin cells. It also thickens sebum within the follicle, encouraging plugs to form. Its comedogenic rating is among the highest of the lanolin family.",
    commonProducts: ["moisturizers", "foundations", "sunscreens", "lotions"],
    alsoKnownAs: ["Wool Wax Alcohol", "Sterols"],
  },
  {
    name: "PEG 16 Lanolin",
    slug: "peg-16-lanolin",
    category: "Lanolin Derivative",
    description:
      "A polyethylene glycol derivative of lanolin designed to improve lanolin's solubility and reduce its sticky texture.",
    whyUsed:
      "Formulators use it to get the moisturizing benefits of lanolin in lighter-feeling, more elegant formulations that blend easily.",
    whyClogsPores:
      "Even with PEG modification, this derivative retains enough of lanolin's occlusive nature to block pores. It leaves a film on skin that interferes with the normal flow of sebum out of follicles. Acne-prone skin is especially susceptible to breakouts from this ingredient.",
    commonProducts: ["moisturizers", "hair products", "body lotions"],
    alsoKnownAs: [],
  },
  {
    name: "Solulan 16",
    slug: "solulan-16",
    category: "Lanolin Derivative",
    description:
      "A brand-name ethoxylated lanolin alcohol that has been modified with 16 moles of ethylene oxide for improved solubility.",
    whyUsed:
      "It acts as a nonionic emulsifier and superfatting agent, helping products feel richer and more moisturizing.",
    whyClogsPores:
      "Solulan 16 has been shown to be highly comedogenic in rabbit ear assays. It deposits a residue on skin that blocks the follicular opening, preventing sebum from exiting normally. This makes it one of the worst offenders for triggering closed comedones.",
    commonProducts: ["creams", "lotions", "hair conditioners"],
    alsoKnownAs: ["Laneth-16"],
  },

  // ─── Algae & Seaweed ───
  {
    name: "Active Soil Complex",
    slug: "active-soil-complex",
    category: "Other",
    description:
      "A proprietary blend of soil-derived minerals and organic compounds marketed as a nutrient-rich skin treatment.",
    whyUsed:
      "Brands use it to claim mineral-rich, earth-sourced nourishment for the skin, positioning products as natural and nutrient-dense.",
    whyClogsPores:
      "Soil-derived complexes often contain heavy mineral particles and organic matter that can physically block pores. The dense, unrefined nature of these blends makes them difficult for skin to process. They can also create an occlusive layer that traps bacteria and sebum.",
    commonProducts: ["serums", "masks", "moisturizers"],
    alsoKnownAs: [],
  },
  {
    name: "Ahnfeltia Concinna",
    slug: "ahnfeltia-concinna",
    category: "Algae & Seaweed",
    description:
      "A species of red algae found in coastal waters, used in cosmetics for its gel-forming polysaccharides.",
    whyUsed:
      "It provides a natural thickening and gelling effect in formulations and is marketed as a clean, marine-derived alternative to synthetic thickeners.",
    whyClogsPores:
      "Like many algae extracts, Ahnfeltia Concinna contains iodides and other halides that can irritate follicular walls and trigger breakouts. Its gel-forming polysaccharides can also create a film that traps sebum. For acne-prone skin, this combination is a recipe for clogged pores.",
    commonProducts: ["serums", "gel moisturizers", "masks"],
    alsoKnownAs: [],
  },
  {
    name: "Alaria Esculenta",
    slug: "alaria-esculenta",
    category: "Algae & Seaweed",
    description:
      "An edible brown kelp commonly known as winged kelp, harvested from the North Atlantic for its mineral-rich extract.",
    whyUsed:
      "It's rich in vitamins and antioxidants, making it a popular \"superfood\" ingredient in anti-aging and hydrating skincare.",
    whyClogsPores:
      "Brown kelps like Alaria Esculenta are notably high in iodides, which can aggravate acne by causing follicular irritation. The extract can also leave a sticky film on skin that hinders pore function. People with acne-prone skin often see flare-ups after using products with this ingredient.",
    commonProducts: ["serums", "moisturizers", "eye creams", "masks"],
    alsoKnownAs: ["Winged Kelp", "Dabberlocks"],
  },
  {
    name: "Algae Extract",
    slug: "algae-extract",
    category: "Algae & Seaweed",
    description:
      "A broad term for extracts derived from various species of freshwater or marine algae, packed with minerals, amino acids, and polysaccharides.",
    whyUsed:
      "It's a skincare darling for hydration, antioxidant protection, and anti-aging claims — you'll see it in everything from serums to sheet masks.",
    whyClogsPores:
      "Algae extracts are high in iodides and sulfated polysaccharides that can irritate hair follicles and promote comedone formation. They also form a biofilm on skin that traps sebum and dead cells inside pores. This is one of the most common hidden acne triggers in \"clean\" skincare.",
    commonProducts: ["serums", "moisturizers", "masks", "toners", "eye creams"],
    alsoKnownAs: ["Seaweed Extract", "Marine Extract"],
  },
  {
    name: "Algin",
    slug: "algin",
    category: "Algae & Seaweed",
    description:
      "A polysaccharide extracted from the cell walls of brown algae, commonly used as a natural gelling and thickening agent.",
    whyUsed:
      "It's a versatile thickener and stabilizer that gives products a smooth, gel-like texture without synthetic additives.",
    whyClogsPores:
      "Algin forms a moisture-trapping film on the skin surface that can seal pores shut. As an algae derivative, it also carries iodides that irritate the follicular lining. This combination of pore-sealing film and iodide content makes it problematic for breakout-prone skin.",
    commonProducts: ["masks", "gel moisturizers", "serums", "peel-off masks"],
    alsoKnownAs: ["Alginic Acid", "Sodium Alginate"],
  },
  {
    name: "Ascophyllum Nodosum",
    slug: "ascophyllum-nodosum",
    category: "Algae & Seaweed",
    description:
      "A large brown seaweed also known as knotted wrack, found on rocky shores of the North Atlantic.",
    whyUsed:
      "It's prized for its rich mineral profile and antioxidant polyphenols, making it a popular anti-aging and skin-firming ingredient.",
    whyClogsPores:
      "This brown seaweed is exceptionally high in iodine, which is known to exacerbate acne by irritating the follicular epithelium. Its polysaccharides also form an occlusive layer that can trap sebum. If you're acne-prone, iodine-rich seaweeds like this are best avoided.",
    commonProducts: ["anti-aging serums", "moisturizers", "body wraps"],
    alsoKnownAs: ["Knotted Wrack", "Egg Wrack", "Rockweed"],
  },
  {
    name: "Black Kelp",
    slug: "black-kelp",
    category: "Algae & Seaweed",
    description:
      "A type of large brown seaweed harvested from cold ocean waters, rich in minerals and trace elements.",
    whyUsed:
      "Brands market it for its detoxifying and mineral-replenishing claims, positioning it as a deep-sea skincare superfood.",
    whyClogsPores:
      "Black kelp is loaded with iodides that trigger acne flares by inflaming the walls of hair follicles. It also deposits a heavy, mineral-laden film on skin that impedes normal pore drainage. This double action makes it a potent pore-clogger for sensitive skin.",
    commonProducts: ["masks", "body treatments", "moisturizers"],
    alsoKnownAs: [],
  },
  {
    name: "Bladderwack",
    slug: "bladderwack",
    category: "Algae & Seaweed",
    description:
      "A type of brown seaweed (Fucus vesiculosus) recognized by its paired air bladders, commonly found along Northern Atlantic coastlines.",
    whyUsed:
      "It's a traditional skincare ingredient valued for its high mineral content, especially iodine, and its anti-inflammatory and skin-firming properties.",
    whyClogsPores:
      "Bladderwrack is one of the highest-iodine seaweeds used in cosmetics, and iodides are a well-documented acne trigger. The extract creates a sticky polysaccharide layer that blocks pore openings. Combined with its iodine content, this makes it a serious concern for acne-prone skin.",
    commonProducts: ["body wraps", "anti-cellulite creams", "serums", "masks"],
    alsoKnownAs: ["Fucus Vesiculosus", "Bladder Wrack", "Sea Oak"],
  },
  {
    name: "Blue Algae",
    slug: "blue-algae",
    category: "Algae & Seaweed",
    description:
      "Cyanobacteria that produce blue pigments, often harvested from freshwater lakes and marketed as nutrient-rich skincare actives.",
    whyUsed:
      "It's trending in clean beauty for its protein content, antioxidant properties, and bright blue color that looks striking in products.",
    whyClogsPores:
      "Blue algae extracts form a protein-rich biofilm on the skin surface that can block pore openings. They also contain compounds that stimulate excess cell turnover at the follicle mouth, which paradoxically leads to more dead-cell buildup. Their iodide content further compounds the pore-clogging risk.",
    commonProducts: ["serums", "moisturizers", "masks", "eye creams"],
    alsoKnownAs: ["Cyanobacteria", "Aphanizomenon Flos-Aquae"],
  },
  {
    name: "Blue Green Algae",
    slug: "blue-green-algae",
    category: "Algae & Seaweed",
    description:
      "A group of photosynthetic cyanobacteria from freshwater environments, rich in proteins, vitamins, and essential fatty acids.",
    whyUsed:
      "Beauty brands use it for its impressive nutrient density, antioxidant power, and marketing appeal as a natural superfood for skin.",
    whyClogsPores:
      "Blue-green algae deposit a sticky biofilm layer on the skin that seals pores and prevents sebum from escaping. They contain iodides and other minerals that irritate the follicular lining, promoting inflammation. This creates a cycle of clogged pores and breakouts in acne-prone individuals.",
    commonProducts: ["serums", "moisturizers", "facial oils", "masks"],
    alsoKnownAs: ["Spirulina", "AFA Algae", "Cyanophyta"],
  },
  {
    name: "Brown Algae",
    slug: "brown-algae",
    category: "Algae & Seaweed",
    description:
      "A large group of marine algae (Phaeophyta) including kelps and wracks, known for their high mineral and polysaccharide content.",
    whyUsed:
      "They provide antioxidants, hydration, and skin-firming benefits, making them staple ingredients in marine-based skincare lines.",
    whyClogsPores:
      "Brown algae species contain some of the highest iodide concentrations of any cosmetic ingredient, and iodides are proven acne aggravators. Their alginates form a gel-like film that physically blocks pores. This one-two punch of chemical irritation and physical obstruction is bad news for breakout-prone skin.",
    commonProducts: ["moisturizers", "serums", "anti-aging creams", "masks"],
    alsoKnownAs: ["Phaeophyta", "Laminaria", "Fucus"],
  },
  {
    name: "Carrageenan",
    slug: "carrageenan",
    category: "Algae & Seaweed",
    description:
      "A family of sulfated polysaccharides extracted from red seaweeds, widely used as a gelling and thickening agent.",
    whyUsed:
      "It gives products a smooth, gel-like consistency and helps stabilize emulsions — it's the reason some creams feel so luxuriously thick.",
    whyClogsPores:
      "Carrageenan forms a heavy, pore-sealing gel film on the skin surface that prevents sebum from flowing out of follicles. As a sulfated polysaccharide from seaweed, it also carries iodides that irritate pore walls. It's a sneaky pore-clogger because it's often listed as just a \"thickener.\"",
    commonProducts: ["moisturizers", "toothpaste", "body lotions", "hair gels"],
    alsoKnownAs: ["Irish Moss Extract", "Chondrus Extract"],
  },
  {
    name: "Carrageenan Moss",
    slug: "carrageenan-moss",
    category: "Algae & Seaweed",
    description:
      "The raw red seaweed from which carrageenan is derived, typically Chondrus crispus or similar species.",
    whyUsed:
      "It's used as a less-processed, more \"natural\" source of carrageenan, appealing to clean beauty formulations.",
    whyClogsPores:
      "As the unrefined source of carrageenan, this moss carries even more iodides and sulfated polysaccharides than the purified extract. It forms a thick gel layer on skin that blocks pore openings. The high iodide concentration also triggers follicular inflammation in acne-prone skin.",
    commonProducts: ["masks", "natural moisturizers", "body treatments"],
    alsoKnownAs: ["Irish Moss", "Chondrus Crispus"],
  },
  {
    name: "Chlorella",
    slug: "chlorella",
    category: "Algae & Seaweed",
    description:
      "A single-celled green freshwater algae famous for its high chlorophyll content and dense nutritional profile.",
    whyUsed:
      "Skincare brands market it as a detoxifying, skin-brightening ingredient packed with growth factors and antioxidants.",
    whyClogsPores:
      "Chlorella's cell wall fragments can physically clog pores, and its extract forms a protein-rich film on the skin that blocks sebum flow. It also contains growth factors that may stimulate excess keratinocyte production in the follicle. This leads to a buildup of dead cells that plug the pore opening.",
    commonProducts: ["serums", "masks", "moisturizers", "eye creams"],
    alsoKnownAs: ["Chlorella Vulgaris"],
  },
  {
    name: "Chondrus Crispus",
    slug: "chondrus-crispus",
    category: "Algae & Seaweed",
    description:
      "A species of red algae from the Atlantic coast, also known as Irish Moss, that produces carrageenan when processed.",
    whyUsed:
      "It's a natural emollient and film-former that gives products a smooth, hydrating feel and is popular in natural and organic formulations.",
    whyClogsPores:
      "Chondrus Crispus is rich in sulfated polysaccharides that form a thick occlusive gel on skin, trapping sebum in follicles. Its high iodide content inflames the pore lining, making breakouts more likely. This is one of the most common seaweed-derived pore cloggers in \"natural\" skincare.",
    commonProducts: ["moisturizers", "serums", "gel masks", "hair products"],
    alsoKnownAs: ["Irish Moss", "Carrageen Moss"],
  },
  {
    name: "Corallina Officinalis",
    slug: "corallina-officinalis",
    category: "Algae & Seaweed",
    description:
      "A calcified red algae that forms hard, coral-like structures in shallow marine waters, rich in calcium carbonate and minerals.",
    whyUsed:
      "It's used for its mineral content and exfoliating micro-particles, and marketed as a marine-sourced skin-renewing ingredient.",
    whyClogsPores:
      "The calcium carbonate particles from this algae can physically block pores and create micro-irritation. Its marine-derived minerals include iodides that trigger follicular inflammation. Together, the physical blockage and chemical irritation make it a pore-clogging concern.",
    commonProducts: ["exfoliators", "masks", "anti-aging creams"],
    alsoKnownAs: ["Coral Seaweed", "Coralline Algae"],
  },
  {
    name: "Dilsea Carnosa",
    slug: "dilsea-carnosa",
    category: "Algae & Seaweed",
    description:
      "A fleshy red seaweed found in the North Atlantic, used in cosmetics for its moisturizing polysaccharides.",
    whyUsed:
      "It provides hydration and is marketed as a gentle, marine-sourced skin conditioner in premium skincare lines.",
    whyClogsPores:
      "Like other red algae, Dilsea Carnosa releases sulfated polysaccharides that form a film on skin and trap sebum in pores. It also contains iodide compounds that irritate the follicular epithelium. Acne-prone individuals should watch for this ingredient in marine-themed product lines.",
    commonProducts: ["moisturizers", "serums", "masks"],
    alsoKnownAs: [],
  },
  {
    name: "Dulse",
    slug: "dulse",
    category: "Algae & Seaweed",
    description:
      "An edible red seaweed (Palmaria palmata) harvested from northern coastlines, with a high protein and mineral content.",
    whyUsed:
      "It's used as a nutrient-rich extract that provides vitamins, trace minerals, and amino acids to skincare products.",
    whyClogsPores:
      "Dulse has a significant iodide content that can trigger acne flare-ups by inflaming the follicular wall. Its polysaccharides leave a residue on skin that impedes normal pore drainage. Products containing dulse may cause unexpected breakouts even in otherwise gentle formulations.",
    commonProducts: ["masks", "serums", "body treatments"],
    alsoKnownAs: ["Palmaria Palmata", "Sea Lettuce Flakes", "Dillisk"],
  },
  {
    name: "Ecklonia",
    slug: "ecklonia",
    category: "Algae & Seaweed",
    description:
      "A genus of brown kelp found mainly in the Southern Hemisphere and East Asia, used for its potent antioxidant compounds like phlorotannins.",
    whyUsed:
      "It's valued for its strong antioxidant and anti-inflammatory properties, often positioned as a high-performance anti-aging ingredient.",
    whyClogsPores:
      "Ecklonia is a brown algae with high iodide content that aggravates acne by irritating hair follicle linings. Its polysaccharides also create an occlusive layer that prevents sebum from draining properly. Despite its anti-inflammatory marketing, it can paradoxically trigger breakouts in acne-prone skin.",
    commonProducts: ["anti-aging serums", "moisturizers", "eye creams"],
    alsoKnownAs: ["Ecklonia Cava", "Ecklonia Radiata"],
  },
  {
    name: "Enteromorpha Compressa",
    slug: "enteromorpha-compressa",
    category: "Algae & Seaweed",
    description:
      "A tubular green seaweed found in coastal waters worldwide, known for its high content of vitamins and polysaccharides.",
    whyUsed:
      "It's included in formulations for its hydrating and skin-conditioning properties, and as a natural source of marine vitamins.",
    whyClogsPores:
      "This green algae forms a polysaccharide film on the skin that seals pore openings and traps sebum. Its mineral content, including iodides, can also irritate the follicular wall. The combination of film formation and iodide irritation makes it comedogenic for breakout-prone skin.",
    commonProducts: ["moisturizers", "serums", "marine-themed skincare"],
    alsoKnownAs: ["Ulva Compressa", "Gut Weed"],
  },
  {
    name: "Fucus Vesiculosus",
    slug: "fucus-vesiculosus",
    category: "Algae & Seaweed",
    description:
      "A common brown seaweed found on rocky shores of the North Atlantic, widely known as bladderwrack.",
    whyUsed:
      "It's rich in fucoidan, minerals, and antioxidants, making it popular for anti-aging, firming, and mineral-replenishing products.",
    whyClogsPores:
      "Fucus vesiculosus contains one of the highest iodine concentrations of any cosmetic seaweed, and iodine is a known acne trigger. Its fucoidan and alginate compounds form an occlusive gel that physically obstructs pores. This is a major hidden acne trigger, especially in \"marine\" and \"ocean\" skincare lines.",
    commonProducts: ["anti-aging serums", "body wraps", "firming creams", "masks"],
    alsoKnownAs: ["Bladderwrack", "Bladder Fucus", "Sea Oak"],
  },
  {
    name: "Haslea Ostrearia",
    slug: "haslea-ostrearia",
    category: "Algae & Seaweed",
    description:
      "A unique blue-pigmented diatom (microalgae) known for producing marennine, a blue-green pigment with bioactive properties.",
    whyUsed:
      "It's a trendy ingredient in luxury skincare for its rare blue pigment and claimed soothing and protective properties.",
    whyClogsPores:
      "Haslea Ostrearia's biofilm-forming tendencies create a layer on skin that seals pore openings. The marennine pigment itself can also deposit within follicles and contribute to blockages. Its algae-derived polysaccharides compound this effect by thickening the occlusive layer.",
    commonProducts: ["luxury serums", "moisturizers", "eye creams"],
    alsoKnownAs: ["Blue Diatom", "Navicula"],
  },
  {
    name: "Himanthalia Elongate",
    slug: "himanthalia-elongate",
    category: "Algae & Seaweed",
    description:
      "A brown seaweed also known as sea spaghetti, found along European Atlantic coasts, valued for its mineral richness.",
    whyUsed:
      "Its extract provides hydration, antioxidants, and minerals, and is marketed as a sea-derived youth-boosting ingredient.",
    whyClogsPores:
      "As a brown algae, Himanthalia Elongate is rich in iodides that trigger follicular inflammation and breakouts. Its polysaccharides form a sticky film on the skin that blocks pore drainage. The combination of high iodide content and occlusive residue makes it highly comedogenic.",
    commonProducts: ["moisturizers", "anti-aging serums", "masks"],
    alsoKnownAs: ["Sea Spaghetti", "Sea Thong"],
  },
  {
    name: "Hydrolyzed Lola Implexa",
    slug: "hydrolyzed-lola-implexa",
    category: "Algae & Seaweed",
    description:
      "A hydrolyzed extract of Lola Implexa, a filamentous green algae broken down into smaller molecules for easier skin absorption.",
    whyUsed:
      "Hydrolysis makes the algae's nutrients more bioavailable, and it's used for its conditioning and hydrating properties in premium formulations.",
    whyClogsPores:
      "Even in hydrolyzed form, this algae extract deposits pore-blocking residues on the skin. The smaller molecular fragments can actually penetrate deeper into follicles and cause irritation from within. Its iodide content further aggravates acne-prone skin.",
    commonProducts: ["serums", "moisturizers", "luxury creams"],
    alsoKnownAs: [],
  },
  {
    name: "Hydrolyzed Rhodophycea",
    slug: "hydrolyzed-rhodophycea",
    category: "Algae & Seaweed",
    description:
      "A hydrolyzed extract from red algae (Rhodophyta), broken down for improved penetration and bioavailability in skincare.",
    whyUsed:
      "It delivers marine polysaccharides and minerals deep into the skin, used for hydration and anti-aging benefits.",
    whyClogsPores:
      "Hydrolyzed red algae retains the sulfated polysaccharides and iodides that make the Rhodophyta family problematic for acne. These fragments form a film within and over pores, trapping sebum. The iodide content also inflames the follicular lining, compounding the breakout risk.",
    commonProducts: ["serums", "anti-aging creams", "masks"],
    alsoKnownAs: ["Hydrolyzed Red Algae"],
  },
  {
    name: "Hypnea Musciformis",
    slug: "hypnea-musciformis",
    category: "Algae & Seaweed",
    description:
      "A red seaweed found in tropical and subtropical waters, used as a source of carrageenan and other gel-forming polysaccharides.",
    whyUsed:
      "It's used for its natural thickening and gelling properties, providing a smooth texture to creams and gels.",
    whyClogsPores:
      "Hypnea Musciformis releases carrageenan-type polysaccharides that form a pore-sealing gel on the skin surface. Its high iodide content inflames follicles and triggers comedone formation. As a carrageenan source, it carries the same comedogenic risks as purified carrageenan.",
    commonProducts: ["gel moisturizers", "masks", "body lotions"],
    alsoKnownAs: ["Hookweed"],
  },
  {
    name: "Irish Moss",
    slug: "irish-moss",
    category: "Algae & Seaweed",
    description:
      "The common name for Chondrus crispus, a red seaweed traditionally harvested from the Atlantic coast of Ireland and Europe.",
    whyUsed:
      "It's a natural emollient and thickener beloved in clean beauty for its gel-forming ability and marine nutrient content.",
    whyClogsPores:
      "Irish moss is essentially carrageenan in its whole form — it produces sulfated polysaccharides that create a thick pore-blocking gel on skin. Its iodide content is high enough to irritate follicles and trigger inflammatory acne. Don't be fooled by its natural reputation; it's a known comedogenic ingredient.",
    commonProducts: ["moisturizers", "masks", "hair gels", "body lotions"],
    alsoKnownAs: ["Chondrus Crispus", "Carrageen Moss", "Sea Moss"],
  },
  {
    name: "Kelp",
    slug: "kelp",
    category: "Algae & Seaweed",
    description:
      "A general term for large brown seaweeds of the order Laminariales, some of the most mineral-rich marine plants on Earth.",
    whyUsed:
      "It's packed with vitamins, minerals, and antioxidants, making it one of the most popular marine ingredients in skincare.",
    whyClogsPores:
      "Kelp species contain extremely high levels of iodides — one of the most well-established acne-triggering substances in dermatology. The alginates in kelp also form an occlusive gel that physically blocks pore drainage. For acne-prone skin, kelp in any form is best avoided entirely.",
    commonProducts: ["masks", "serums", "body wraps", "moisturizers", "shampoos"],
    alsoKnownAs: ["Laminaria", "Macrocystis"],
  },
  {
    name: "Laminaria Digitata",
    slug: "laminaria-digitata",
    category: "Algae & Seaweed",
    description:
      "A large brown kelp known as oarweed, found in the North Atlantic, prized for its exceptionally high mineral content.",
    whyUsed:
      "It delivers a potent dose of minerals, fucoidan, and laminarin, making it a premium anti-aging and hydrating ingredient.",
    whyClogsPores:
      "Laminaria digitata has one of the highest iodine concentrations among kelp species, making it a significant acne trigger. Its alginates form a gel-like film that seals pore openings and traps sebum inside. This kelp is particularly problematic because it's so widely used in high-end marine skincare.",
    commonProducts: ["anti-aging serums", "moisturizers", "masks", "eye creams"],
    alsoKnownAs: ["Oarweed", "Horsetail Kelp"],
  },
  {
    name: "Laminaria Longicruris",
    slug: "laminaria-longicruris",
    category: "Algae & Seaweed",
    description:
      "A long-stalked kelp native to the Northwest Atlantic, used in cosmetics for its mineral-rich extract.",
    whyUsed:
      "It's valued for its high concentration of laminarin and fucoidan, used in anti-aging and skin-firming products.",
    whyClogsPores:
      "Like all Laminaria species, this kelp is rich in iodides that irritate the follicular epithelium and trigger acne. Its polysaccharides form a sticky residue on skin that blocks normal pore function. The high mineral load can also disrupt the skin's natural balance.",
    commonProducts: ["serums", "moisturizers", "body treatments"],
    alsoKnownAs: ["Long-Stalked Kelp"],
  },
  {
    name: "Laminaria Saccharine",
    slug: "laminaria-saccharine",
    category: "Algae & Seaweed",
    description:
      "A sweet kelp species from the North Atlantic, named for its slightly sweet taste due to the sugar alcohol mannitol.",
    whyUsed:
      "Its extract is used for hydrating, skin-soothing, and anti-aging properties, often in premium marine skincare.",
    whyClogsPores:
      "Laminaria Saccharine contains high iodide levels that inflame hair follicles and promote comedone formation. Its mannitol and alginate content create a hygroscopic film that swells on the skin and blocks pore openings. Acne-prone skin is especially reactive to this kelp's iodide load.",
    commonProducts: ["moisturizers", "serums", "anti-aging treatments"],
    alsoKnownAs: ["Sugar Kelp", "Saccharina Latissima", "Sweet Kelp"],
  },
  {
    name: "Lithothamnium Calcareum",
    slug: "lithothamnium-calcareum",
    category: "Algae & Seaweed",
    description:
      "A calcified red algae that forms limestone-like deposits on the sea floor, harvested for its exceptionally high calcium and mineral content.",
    whyUsed:
      "It's used as a natural mineral source and gentle exfoliant, adding calcium, magnesium, and trace minerals to formulations.",
    whyClogsPores:
      "The calcium carbonate particles from this algae can physically block pores and cause micro-abrasions that lead to inflammation. Its mineral-dense residue sits on the skin surface and impedes sebum flow. For acne-prone skin, the combination of physical occlusion and mineral irritation can trigger breakouts.",
    commonProducts: ["mineral foundations", "exfoliators", "masks", "mineral sunscreens"],
    alsoKnownAs: ["Maerl", "Calcified Seaweed"],
  },
  {
    name: "Lola Implexa",
    slug: "lola-implexa",
    category: "Algae & Seaweed",
    description:
      "A filamentous green algae found in marine environments, used in skincare for its polysaccharide and mineral content.",
    whyUsed:
      "It provides conditioning and hydrating benefits, often included in marine-themed natural skincare lines.",
    whyClogsPores:
      "Lola Implexa produces polysaccharides that form a sticky film over pores, trapping sebum and dead skin cells. Its marine mineral content includes iodides that irritate the follicular lining. This makes it a hidden pore-clogger in products marketed as gentle and natural.",
    commonProducts: ["moisturizers", "serums", "masks"],
    alsoKnownAs: [],
  },
  {
    name: "Marine Algae",
    slug: "marine-algae",
    category: "Algae & Seaweed",
    description:
      "A catch-all term for any algae harvested from the ocean, encompassing green, brown, and red seaweed species.",
    whyUsed:
      "It's a ubiquitous ingredient in hydrating and anti-aging skincare, prized for marine minerals, antioxidants, and polysaccharides.",
    whyClogsPores:
      "\"Marine algae\" on a label could mean any number of iodide-rich, film-forming seaweed species. Most marine algae form occlusive polysaccharide layers that trap sebum in pores. The vague labeling makes it impossible to know exactly which species you're getting, so it's safest to avoid it entirely if you're acne-prone.",
    commonProducts: ["moisturizers", "serums", "masks", "body lotions", "shampoos"],
    alsoKnownAs: ["Sea Algae", "Ocean Algae"],
  },
  {
    name: "Mastocarpus Stellatus",
    slug: "mastocarpus-stellatus",
    category: "Algae & Seaweed",
    description:
      "A dark red seaweed found on rocky North Atlantic shores, also known as false Irish moss, rich in carrageenans.",
    whyUsed:
      "It's used as a natural carrageenan source, providing thickening, gelling, and moisturizing properties to formulations.",
    whyClogsPores:
      "As a carrageenan-producing seaweed, Mastocarpus Stellatus delivers the same pore-clogging sulfated polysaccharides as Irish moss. These form an occlusive gel that blocks sebum drainage from follicles. Its iodide content adds further irritation to already congested pores.",
    commonProducts: ["moisturizers", "gel creams", "masks"],
    alsoKnownAs: ["False Irish Moss", "Grape Pip Weed"],
  },
  {
    name: "Norwegian Kelp",
    slug: "norwegian-kelp",
    category: "Algae & Seaweed",
    description:
      "Kelp harvested from the cold, nutrient-rich waters off Norway, known for its exceptional mineral density.",
    whyUsed:
      "The harsh growing conditions make Norwegian kelp especially rich in protective antioxidants and minerals, which brands leverage for premium anti-aging claims.",
    whyClogsPores:
      "Norwegian kelp's cold-water growing conditions actually concentrate iodides to even higher levels than warmer-water kelps. These concentrated iodides are potent acne triggers that inflame follicles. Its dense alginate content also forms a thick pore-blocking film on the skin.",
    commonProducts: ["luxury serums", "anti-aging creams", "masks"],
    alsoKnownAs: ["Nordic Kelp", "Arctic Kelp"],
  },
  {
    name: "Padina Pavonica",
    slug: "padina-pavonica",
    category: "Algae & Seaweed",
    description:
      "A fan-shaped brown algae found in the Mediterranean, also known as peacock's tail, rich in minerals and polysaccharides.",
    whyUsed:
      "It's a trendy ingredient in anti-aging skincare, marketed for boosting collagen synthesis and improving skin firmness.",
    whyClogsPores:
      "Padina Pavonica is a calcified brown algae that deposits both mineral particles and sticky polysaccharides on the skin. The mineral residue can physically plug pores, while its iodide content inflames the follicular lining. It's especially common in high-end anti-aging products where acne-prone consumers might not expect it.",
    commonProducts: ["anti-aging serums", "firming creams", "eye treatments"],
    alsoKnownAs: ["Peacock's Tail", "Funnel Weed"],
  },
  {
    name: "Palmaria Palmate",
    slug: "palmaria-palmate",
    category: "Algae & Seaweed",
    description:
      "A reddish-purple edible seaweed from the North Atlantic, one of the most protein-rich sea vegetables available.",
    whyUsed:
      "It's used for its high protein and amino acid content, offering skin-conditioning and anti-aging benefits.",
    whyClogsPores:
      "Palmaria Palmate's proteins and polysaccharides form a residue on skin that blocks pore openings. As a red algae, it carries iodides and sulfated compounds that irritate the follicular wall. The protein film it creates is especially problematic because it acts like a pore-sealing glue.",
    commonProducts: ["serums", "moisturizers", "masks", "marine skincare"],
    alsoKnownAs: ["Dulse"],
  },
  {
    name: "Phytessence Wakame",
    slug: "phytessence-wakame",
    category: "Algae & Seaweed",
    description:
      "A proprietary extract of Undaria pinnatifida (wakame seaweed), standardized for its hyaluronidase-inhibiting properties.",
    whyUsed:
      "Brands market it as a hyaluronic acid protector that prevents the breakdown of the skin's natural moisture barrier.",
    whyClogsPores:
      "Despite being processed, Phytessence Wakame retains the iodide content typical of brown seaweeds that triggers acne. Its polysaccharide-rich extract forms an occlusive film that traps sebum inside pores. The \"hyaluronic acid protection\" marketing obscures its comedogenic potential.",
    commonProducts: ["anti-aging serums", "moisturizers", "eye creams"],
    alsoKnownAs: ["Undaria Pinnatifida Extract"],
  },
  {
    name: "Plankton",
    slug: "plankton",
    category: "Algae & Seaweed",
    description:
      "Microscopic marine organisms (both plant and animal) used in skincare for their rich nutrient profile including proteins, lipids, and minerals.",
    whyUsed:
      "It's positioned as a cutting-edge, bio-marine ingredient that delivers growth factors, peptides, and antioxidants to the skin.",
    whyClogsPores:
      "Plankton extracts create a protein and lipid-rich biofilm on the skin that can seal pore openings. The marine-derived minerals include iodides that irritate follicles and promote breakouts. Because \"plankton\" is vague, there's no way to assess exactly how comedogenic a particular extract is.",
    commonProducts: ["luxury serums", "anti-aging creams", "masks", "essences"],
    alsoKnownAs: ["Marine Plankton", "Phytoplankton", "Zooplankton Extract"],
  },
  {
    name: "Porphyra",
    slug: "porphyra",
    category: "Algae & Seaweed",
    description:
      "A genus of red algae commonly known as nori, widely used in East Asian cuisine and increasingly in cosmetics.",
    whyUsed:
      "It provides vitamins, minerals, and mycosporine-like amino acids that offer natural UV protection and hydration.",
    whyClogsPores:
      "Porphyra's polysaccharides form a sticky layer on the skin surface that blocks pore openings. As a red algae, it contains iodides and sulfated compounds that irritate the follicular lining. Even though nori seems harmless, its extract can trigger comedones in acne-prone individuals.",
    commonProducts: ["serums", "moisturizers", "K-beauty products", "masks"],
    alsoKnownAs: ["Nori", "Laver", "Porphyra Umbilicalis"],
  },
  {
    name: "Porphyridium Cruentum",
    slug: "porphyridium-cruentum",
    category: "Algae & Seaweed",
    description:
      "A unicellular red microalgae that produces exopolysaccharides with a gel-like consistency and a distinct reddish hue.",
    whyUsed:
      "Its exopolysaccharides create a smooth, hydrating film on skin, and it's marketed as a natural alternative to hyaluronic acid.",
    whyClogsPores:
      "The very exopolysaccharides that make this microalgae attractive as a moisturizer are the ones that seal pore openings. This gel-like film prevents sebum from flowing out of follicles, leading to comedone buildup. Its algae-derived minerals add further irritation to the follicular wall.",
    commonProducts: ["hydrating serums", "moisturizers", "luxury creams"],
    alsoKnownAs: ["Red Microalgae"],
  },
  {
    name: "Red Algae",
    slug: "red-algae",
    category: "Algae & Seaweed",
    description:
      "A large group of marine algae (Rhodophyta) that includes thousands of species, known for their sulfated polysaccharides like carrageenan and agar.",
    whyUsed:
      "Red algae extracts are popular for their hydrating, film-forming, and antioxidant properties across all types of skincare products.",
    whyClogsPores:
      "Red algae species produce sulfated polysaccharides that form dense, gel-like films on the skin — essentially plastering over your pores. Their iodide content inflames the follicular wall, triggering inflammatory comedones. When you see \"red algae\" on a label, it could be any of dozens of pore-clogging species.",
    commonProducts: ["moisturizers", "serums", "masks", "gel creams"],
    alsoKnownAs: ["Rhodophyta", "Rhodophyceae"],
  },
  {
    name: "Rockweed",
    slug: "rockweed",
    category: "Algae & Seaweed",
    description:
      "A common name for several brown seaweeds that attach to intertidal rocks, including species of Fucus and Ascophyllum.",
    whyUsed:
      "It's used as a general mineral-rich seaweed extract in natural and marine-themed skincare products.",
    whyClogsPores:
      "Rockweed species are brown algae with high iodide concentrations that trigger follicular inflammation and acne. Their alginates form a thick gel on the skin that physically blocks pore openings. The vague name means you could be getting any number of highly comedogenic brown seaweed species.",
    commonProducts: ["body wraps", "masks", "moisturizers", "bath products"],
    alsoKnownAs: ["Fucus", "Ascophyllum"],
  },
  {
    name: "Sargassum",
    slug: "sargassum",
    category: "Algae & Seaweed",
    description:
      "A genus of large floating brown seaweed found in tropical oceans, notable for forming massive surface mats in the Sargasso Sea.",
    whyUsed:
      "It provides antioxidants, minerals, and alginates, used in skincare for its hydrating and skin-protecting properties.",
    whyClogsPores:
      "Sargassum contains high levels of iodides and produces alginates that form a dense gel film on skin. This film blocks sebum from exiting pores while the iodides inflame the follicular lining. It's a potent combination that makes sargassum one of the more comedogenic seaweed extracts.",
    commonProducts: ["body treatments", "masks", "moisturizers"],
    alsoKnownAs: ["Gulf Weed", "Sea Holly"],
  },
  {
    name: "Seaweed",
    slug: "seaweed",
    category: "Algae & Seaweed",
    description:
      "A broad term for any macroscopic marine algae, covering thousands of species across green, brown, and red varieties.",
    whyUsed:
      "It's one of the trendiest skincare ingredients, used for hydration, minerals, antioxidants, and \"ocean-powered\" marketing appeal.",
    whyClogsPores:
      "\"Seaweed\" on a label is a red flag for acne-prone skin because it could be any number of iodide-rich, film-forming species. Nearly all seaweed produces polysaccharides that create an occlusive layer blocking pores. The iodide content across most species is high enough to trigger follicular inflammation and breakouts.",
    commonProducts: ["moisturizers", "masks", "serums", "body washes", "shampoos"],
    alsoKnownAs: ["Marine Algae", "Ocean Kelp"],
  },
  {
    name: "Sea Whip",
    slug: "sea-whip",
    category: "Algae & Seaweed",
    description:
      "A soft coral (Pseudopterogorgia) found in Caribbean waters, not technically an algae but often grouped with marine botanicals in skincare.",
    whyUsed:
      "It contains pseudopterosins — compounds with strong anti-inflammatory and analgesic properties — making it popular in sensitive skin products.",
    whyClogsPores:
      "Sea whip extract contains waxy compounds from the coral's tissue that form an occlusive layer over pores. While it's marketed as anti-inflammatory, the marine-derived residue can trap sebum and dead cells in follicles. Its complex chemistry also carries iodides that may aggravate acne.",
    commonProducts: ["sensitive skin creams", "anti-redness serums", "moisturizers"],
    alsoKnownAs: ["Pseudopterogorgia Elisabethae", "Gorgonian Extract"],
  },
  {
    name: "Spirulina",
    slug: "spirulina",
    category: "Algae & Seaweed",
    description:
      "A blue-green cyanobacterium (Arthrospira) cultivated in freshwater, famous as a nutritional supplement and increasingly used in skincare.",
    whyUsed:
      "It's loaded with protein, vitamins, and the antioxidant phycocyanin, marketed as a detoxifying and skin-brightening powerhouse.",
    whyClogsPores:
      "Spirulina creates a protein-dense biofilm on skin that blocks pore openings and traps sebum underneath. Its concentrated mineral content includes compounds that can irritate the follicular wall. Despite its superfood reputation, it's a sneaky pore-clogger that trips up many acne-prone skincare enthusiasts.",
    commonProducts: ["masks", "serums", "moisturizers", "supplements"],
    alsoKnownAs: ["Arthrospira Platensis", "Spirulina Platensis"],
  },
  {
    name: "Ulva Lactuca",
    slug: "ulva-lactuca",
    category: "Algae & Seaweed",
    description:
      "A thin, bright green seaweed commonly known as sea lettuce, found in coastal waters worldwide.",
    whyUsed:
      "It's used for its high vitamin and mineral content, providing hydration and skin conditioning in marine skincare formulations.",
    whyClogsPores:
      "Ulva Lactuca produces polysaccharides (ulvans) that form a film on the skin and block pore drainage. Its marine mineral content includes iodides that trigger follicular irritation. Even though it's a thin, delicate seaweed, its extract has real comedogenic potential for breakout-prone skin.",
    commonProducts: ["moisturizers", "serums", "masks", "body lotions"],
    alsoKnownAs: ["Sea Lettuce", "Green Laver"],
  },
  {
    name: "Undaria",
    slug: "undaria",
    category: "Algae & Seaweed",
    description:
      "A genus of brown kelp best known for Undaria pinnatifida (wakame), a widely cultivated edible seaweed from East Asia.",
    whyUsed:
      "It's rich in fucoxanthin and fucoidan, making it one of the most popular marine ingredients for anti-aging and brightening skincare.",
    whyClogsPores:
      "Undaria species are brown seaweeds with substantial iodide content that inflames follicles and promotes acne. Their polysaccharides form a gel-like coating on skin that prevents sebum from exiting pores. Its popularity in K-beauty and J-beauty products means it catches many acne-prone users off guard.",
    commonProducts: ["serums", "essences", "moisturizers", "masks"],
    alsoKnownAs: ["Wakame", "Undaria Pinnatifida"],
  },
  {
    name: "Wakame",
    slug: "wakame",
    category: "Algae & Seaweed",
    description:
      "An edible brown seaweed (Undaria pinnatifida) widely used in Japanese and Korean cuisine and skincare for its rich nutrient profile.",
    whyUsed:
      "It's a K-beauty and J-beauty staple, prized for hydration, brightening, and its ability to inhibit hyaluronidase (the enzyme that breaks down hyaluronic acid).",
    whyClogsPores:
      "Wakame contains significant iodide levels that trigger follicular inflammation and acne breakouts. Its fucoidan and alginate compounds form an occlusive gel that seals pore openings. If you're acne-prone, this is one of the biggest hidden triggers in Asian-influenced skincare products.",
    commonProducts: ["essences", "serums", "moisturizers", "sheet masks"],
    alsoKnownAs: ["Undaria Pinnatifida", "Sea Mustard"],
  },

  // ─── Oils ───
  {
    name: "Argan Oil",
    slug: "argan-oil",
    category: "Oil",
    description:
      "A plant oil extracted from the kernels of the Moroccan argan tree (Argania spinosa), rich in oleic acid, vitamin E, and squalene.",
    whyUsed:
      "It's a premium moisturizing oil beloved for its ability to soften skin and hair without feeling too heavy.",
    whyClogsPores:
      "Argan oil contains around 45% oleic acid, which is known to disrupt the skin barrier and penetrate into pores, where it promotes comedone formation. Its rich lipid profile creates an occlusive layer that traps dead cells. For oily or acne-prone skin, the oleic acid content is the main concern.",
    commonProducts: ["facial oils", "hair oils", "moisturizers", "serums"],
    alsoKnownAs: ["Argania Spinosa Kernel Oil", "Moroccan Oil"],
  },
  {
    name: "Avocado Oil",
    slug: "avocado-oil",
    category: "Oil",
    description:
      "A thick, nutrient-rich oil pressed from the flesh of avocados, high in oleic acid, vitamins A/D/E, and phytosterols.",
    whyUsed:
      "Its deeply moisturizing properties and vitamin content make it popular in nourishing creams, especially for dry and mature skin.",
    whyClogsPores:
      "Avocado oil has a heavy consistency and is high in oleic acid (about 60%), which disrupts the lipid balance in pores and promotes comedone formation. Its thick texture creates a strong occlusive barrier that traps sebum. It's one of the heavier plant oils and is especially problematic for oily or combination skin.",
    commonProducts: ["moisturizers", "body butters", "hair masks", "lip balms"],
    alsoKnownAs: ["Persea Gratissima Oil"],
  },
  {
    name: "Cocos Nucifera (Coconut) Oil",
    slug: "cocos-nucifera-coconut-oil",
    category: "Oil",
    description:
      "A saturated fat extracted from the meat of coconuts, solid at room temperature and composed primarily of lauric acid and myristic acid.",
    whyUsed:
      "It's cheap, smells amazing, and has antimicrobial properties — making it one of the most widely used oils in beauty products.",
    whyClogsPores:
      "Coconut oil is one of the most comedogenic oils, scoring a 4 out of 5 on comedogenicity scales. Its high lauric and myristic acid content creates a thick, waxy layer that solidifies in pores and is very difficult for the skin to break down. It's the number one oil that acne-prone people should avoid.",
    commonProducts: ["moisturizers", "shampoos", "lip balms", "body lotions", "hair products"],
    alsoKnownAs: ["Coconut Oil", "Copra Oil"],
  },
  {
    name: "Cotton Seed Oil",
    slug: "cotton-seed-oil",
    category: "Oil",
    description:
      "An oil extracted from the seeds of cotton plants, with a balanced fatty acid profile of palmitic, oleic, and linoleic acids.",
    whyUsed:
      "It's an inexpensive emollient that blends well into formulations and provides moderate moisturization.",
    whyClogsPores:
      "Cottonseed oil has a moderately comedogenic fatty acid profile that can contribute to pore blockage, especially on oily skin. Its combination of palmitic and oleic acids creates a film that's thick enough to trap sebum. It's particularly problematic because it's often used as a filler oil in budget formulations.",
    commonProducts: ["moisturizers", "body lotions", "soaps", "massage oils"],
    alsoKnownAs: ["Gossypium Herbaceum Oil"],
  },
  {
    name: "Evening Primrose Oil",
    slug: "evening-primrose-oil",
    category: "Oil",
    description:
      "An oil extracted from the seeds of Oenothera biennis, exceptionally high in gamma-linolenic acid (GLA), an omega-6 fatty acid.",
    whyUsed:
      "It's marketed for its anti-inflammatory GLA content and is popular in products targeting eczema, hormonal skin issues, and dryness.",
    whyClogsPores:
      "Despite its beneficial GLA content, evening primrose oil is moderately comedogenic due to its overall lipid profile. It can form an occlusive film on skin that traps sebum and dead cells in follicles. For acne-prone skin, the pore-clogging risk often outweighs the anti-inflammatory benefits.",
    commonProducts: ["facial oils", "serums", "moisturizers", "supplements"],
    alsoKnownAs: ["Oenothera Biennis Oil", "EPO"],
  },
  {
    name: "Grapeseed Oil",
    slug: "grapeseed-oil",
    category: "Oil",
    description:
      "A light oil pressed from the seeds of grapes (Vitis vinifera), high in linoleic acid and vitamin E.",
    whyUsed:
      "It's popular as a lightweight, fast-absorbing oil that provides moisture without feeling greasy, often recommended for oily skin types.",
    whyClogsPores:
      "While lighter than many oils, grapeseed oil can still clog pores in acne-prone individuals. Its emollient properties create a subtle film that can trap bacteria and dead cells inside follicles over time. Even \"non-comedogenic\" oils like grapeseed can cause issues with prolonged, heavy application.",
    commonProducts: ["facial oils", "moisturizers", "serums", "massage oils"],
    alsoKnownAs: ["Vitis Vinifera Seed Oil"],
  },
  {
    name: "Linseed Oil",
    slug: "linseed-oil",
    category: "Oil",
    description:
      "An oil derived from the seeds of the flax plant (Linum usitatissimum), rich in alpha-linolenic acid (an omega-3 fatty acid).",
    whyUsed:
      "It's valued for its omega-3 content and skin-conditioning properties, used in moisturizers and natural skincare lines.",
    whyClogsPores:
      "Linseed oil has a moderately comedogenic fatty acid profile and can oxidize quickly on the skin, creating a sticky residue that blocks pores. Its thick consistency leaves an occlusive film that prevents sebum drainage. The oxidation products can also irritate follicular walls and worsen breakouts.",
    commonProducts: ["moisturizers", "body oils", "natural skincare", "hair products"],
    alsoKnownAs: ["Flaxseed Oil", "Linum Usitatissimum Seed Oil"],
  },
  {
    name: "Mink Oil",
    slug: "mink-oil",
    category: "Oil",
    description:
      "An animal-derived oil rendered from the fat layer of mink pelts, with a fatty acid composition similar to human sebum.",
    whyUsed:
      "Its similarity to human skin lipids makes it an effective emollient that absorbs well and conditions both skin and leather.",
    whyClogsPores:
      "Mink oil's similarity to human sebum is actually what makes it comedogenic — it essentially adds more of what your skin already overproduces if you're acne-prone. It creates a heavy occlusive layer that traps dead cells in follicles. It's one of the more highly rated comedogenic animal oils.",
    commonProducts: ["hair products", "moisturizers", "leather conditioners", "lip products"],
    alsoKnownAs: ["Mustela Oil"],
  },
  {
    name: "Peanut Oil",
    slug: "peanut-oil",
    category: "Oil",
    description:
      "An oil pressed from peanuts (Arachis hypogaea), containing a mix of oleic, linoleic, and palmitic fatty acids.",
    whyUsed:
      "It's an affordable emollient used in moisturizers and some pharmaceutical preparations for its skin-softening properties.",
    whyClogsPores:
      "Peanut oil has a moderately comedogenic profile due to its oleic acid content, which disrupts the lipid balance in pores. It creates an occlusive film that can trap sebum and dead cells. Additionally, its heavier molecular weight makes it slow to absorb, leaving a pore-blocking residue on skin.",
    commonProducts: ["moisturizers", "body lotions", "pharmaceutical creams", "soaps"],
    alsoKnownAs: ["Arachis Hypogaea Oil", "Groundnut Oil"],
  },
  {
    name: "Rosehip Oil",
    slug: "rosehip-oil",
    category: "Oil",
    description:
      "A pressed oil from the seeds of wild rose bushes (Rosa canina or Rosa rubiginosa), high in linoleic acid, vitamin A, and vitamin C.",
    whyUsed:
      "It's a beloved facial oil for its skin-brightening, scar-fading, and anti-aging properties, widely recommended in natural skincare.",
    whyClogsPores:
      "While rosehip oil is lower on the comedogenic scale than many oils, it can still clog pores in sensitive, acne-prone skin. Its emollient nature forms a light film that may trap bacteria and dead cells over time. Oxidized rosehip oil (which turns rancid quickly) is especially irritating to follicles.",
    commonProducts: ["facial oils", "serums", "moisturizers", "scar treatments"],
    alsoKnownAs: ["Rosa Canina Seed Oil", "Rosa Mosqueta Oil", "Rosehip Seed Oil"],
  },
  {
    name: "Sesame Oil",
    slug: "sesame-oil",
    category: "Oil",
    description:
      "An oil pressed from sesame seeds (Sesamum indicum), rich in oleic and linoleic acids with natural antioxidant properties.",
    whyUsed:
      "It's used in Ayurvedic skincare and massage oils for its deeply moisturizing and warming properties.",
    whyClogsPores:
      "Sesame oil's oleic acid content (about 40%) can disrupt the lipid lining of pores and promote comedone formation. Its relatively thick consistency creates an occlusive barrier that traps sebum inside follicles. It also has a moderate comedogenic rating that makes it risky for acne-prone skin.",
    commonProducts: ["body oils", "massage oils", "moisturizers", "Ayurvedic skincare"],
    alsoKnownAs: ["Sesamum Indicum Seed Oil", "Gingelly Oil"],
  },
  {
    name: "Shark Liver Oil",
    slug: "shark-liver-oil",
    category: "Oil",
    description:
      "An oil derived from the livers of deep-sea sharks, rich in squalene, alkylglycerols, and omega-3 fatty acids.",
    whyUsed:
      "It's valued for its high squalene content and immune-supporting alkylglycerols, used in healing and moisturizing products.",
    whyClogsPores:
      "Shark liver oil is heavy and highly occlusive, forming a thick barrier over pores that prevents sebum from draining. Its lipid-dense composition essentially adds a second layer of oil over already oily skin. For acne-prone individuals, this creates ideal conditions for comedone formation.",
    commonProducts: ["healing balms", "moisturizers", "supplements", "lip treatments"],
    alsoKnownAs: ["Squalus Acanthias Oil", "Squalene Oil"],
  },
  {
    name: "Soybean Oil",
    slug: "soybean-oil",
    category: "Oil",
    description:
      "An oil extracted from soybeans (Glycine max), containing linoleic acid, oleic acid, and phytosterols.",
    whyUsed:
      "It's a widely available, affordable emollient with antioxidant properties, commonly used as a base oil in skincare formulations.",
    whyClogsPores:
      "Soybean oil has a moderately comedogenic fatty acid profile that can block pores in acne-prone skin. Its emollient film traps sebum and dead cells inside follicles. The phytoestrogens in soybean oil may also influence sebum production, potentially worsening hormonal acne.",
    commonProducts: ["moisturizers", "body lotions", "cleansing oils", "soaps"],
    alsoKnownAs: ["Glycine Max Oil", "Glycine Soja Oil"],
  },
  {
    name: "Wheat Germ Oil",
    slug: "wheat-germ-oil",
    category: "Oil",
    description:
      "A thick, nutrient-dense oil extracted from the germ of wheat kernels, exceptionally high in vitamin E and octacosanol.",
    whyUsed:
      "It's used for its potent antioxidant vitamin E content and skin-nourishing properties, popular in anti-aging and dry skin products.",
    whyClogsPores:
      "Wheat germ oil is one of the thickest, heaviest plant oils used in cosmetics, creating a dense occlusive layer over pores. Its high oleic acid content disrupts follicular lipids and promotes comedone formation. It also oxidizes rapidly, and the oxidation byproducts further irritate pore walls.",
    commonProducts: ["moisturizers", "anti-aging creams", "body oils", "hair treatments"],
    alsoKnownAs: ["Triticum Vulgare Germ Oil"],
  },

  // ─── Butters ───
  {
    name: "Cocoa Butter",
    slug: "cocoa-butter",
    category: "Butter",
    description:
      "A rich, solid fat extracted from cacao beans, composed primarily of stearic, oleic, and palmitic fatty acids.",
    whyUsed:
      "It's an incredibly moisturizing emollient that melts at body temperature and gives products a luxurious, creamy texture.",
    whyClogsPores:
      "Cocoa butter rates a 4 out of 5 on comedogenicity scales. Its dense, waxy consistency forms a thick occlusive barrier that seals pores shut and traps sebum, dead cells, and bacteria underneath. It's very slow to absorb, meaning it sits on the surface of skin and blocks follicular openings for hours.",
    commonProducts: ["body butters", "lip balms", "stretch mark creams", "lotions"],
    alsoKnownAs: ["Theobroma Cacao Seed Butter", "Cacao Butter"],
  },
  {
    name: "Coconut Butter",
    slug: "coconut-butter",
    category: "Butter",
    description:
      "A thick paste made from pureed whole coconut meat, containing both the oil and the fiber of the coconut.",
    whyUsed:
      "It provides rich moisturization and has a pleasant tropical scent, used in body care and lip products.",
    whyClogsPores:
      "Coconut butter contains all the comedogenic properties of coconut oil (high in lauric and myristic acids) plus added coconut solids that can physically block pores. The thick paste is extremely occlusive and slow to absorb. It's even more pore-clogging than coconut oil alone due to its dense, fibrous consistency.",
    commonProducts: ["body butters", "lip balms", "body scrubs", "hair masks"],
    alsoKnownAs: ["Coconut Manna", "Creamed Coconut"],
  },
  {
    name: "Shea Butter",
    slug: "shea-butter",
    category: "Butter",
    description:
      "A fat extracted from the nuts of the African shea tree (Vitellaria paradoxa), rich in stearic and oleic acids and vitamins A and E.",
    whyUsed:
      "It's one of the most popular natural moisturizers, used for its deeply hydrating, soothing, and skin-barrier-repairing properties.",
    whyClogsPores:
      "Shea butter has a moderately comedogenic oleic acid content that can disrupt the lipid balance inside pores. Its thick, rich consistency creates a strong occlusive seal over the skin that traps sebum and dead cells. While some acne-prone people tolerate it, many experience breakouts from its heavy pore-coating texture.",
    commonProducts: ["moisturizers", "body butters", "lip balms", "hair products", "soaps"],
    alsoKnownAs: ["Butyrospermum Parkii Butter", "Vitellaria Paradoxa Butter", "Karite Butter"],
  },

  // ─── Esters ───
  {
    name: "Butyl Stearate",
    slug: "butyl-stearate",
    category: "Ester",
    description:
      "A synthetic ester formed from butyl alcohol and stearic acid, used as a lightweight emollient and skin-conditioning agent.",
    whyUsed:
      "It gives products a smooth, non-greasy feel and helps other ingredients spread evenly on the skin.",
    whyClogsPores:
      "Butyl stearate has been shown to be moderately comedogenic in dermatological testing. It penetrates into the follicular opening and creates a lipid plug that blocks sebum drainage. Its molecular structure is just the right size to get trapped in pores and promote comedone formation.",
    commonProducts: ["foundations", "moisturizers", "sunscreens", "body lotions"],
    alsoKnownAs: [],
  },
  {
    name: "Cetyl Acetate",
    slug: "cetyl-acetate",
    category: "Ester",
    description:
      "A waxy ester of cetyl alcohol and acetic acid, used as an emollient and texture-enhancing agent in cosmetics.",
    whyUsed:
      "It provides a smooth, velvety skin feel and helps stabilize emulsions while improving product spreadability.",
    whyClogsPores:
      "Cetyl acetate's waxy molecular structure creates a film over pores that is slow to break down, trapping sebum and dead cells underneath. Its comedogenic rating is moderate to high in testing. The waxy residue it leaves on skin is particularly persistent and difficult for normal skin processes to clear.",
    commonProducts: ["foundations", "moisturizers", "sunscreens", "primers"],
    alsoKnownAs: [],
  },
  {
    name: "Decyl Oleate",
    slug: "decyl-oleate",
    category: "Ester",
    description:
      "A synthetic ester of decyl alcohol and oleic acid, a lightweight emollient that mimics the skin's natural lipids.",
    whyUsed:
      "It spreads easily, absorbs quickly, and gives products a luxurious, non-greasy texture that consumers love.",
    whyClogsPores:
      "Decyl oleate's oleic acid component is a known pore irritant that disrupts the follicular lipid barrier. Even though it feels lightweight, it deposits oleic acid directly into pores where it promotes comedone formation. It's a sneaky comedogenic ingredient because it doesn't feel heavy on the skin.",
    commonProducts: ["moisturizers", "body lotions", "foundations", "sunscreens"],
    alsoKnownAs: [],
  },
  {
    name: "Dioctyl Succinate",
    slug: "dioctyl-succinate",
    category: "Ester",
    description:
      "A diester of 2-ethylhexyl alcohol and succinic acid, used as a lightweight emollient and skin-conditioning agent.",
    whyUsed:
      "It acts as a mild plasticizer and emollient, giving products a smooth, non-tacky finish.",
    whyClogsPores:
      "Dioctyl succinate has been identified as comedogenic in dermatological studies. Its molecular structure allows it to penetrate into the follicular opening and create a lipid layer that impedes sebum flow. Over time this leads to the buildup of plugs within pores.",
    commonProducts: ["moisturizers", "bath oils", "body lotions"],
    alsoKnownAs: ["Bis(2-Ethylhexyl) Succinate"],
  },
  {
    name: "Ethylhexyl Palmitate",
    slug: "ethylhexyl-palmitate",
    category: "Ester",
    description:
      "A synthetic ester of 2-ethylhexanol and palmitic acid, widely used as a lightweight emollient and texture enhancer.",
    whyUsed:
      "It gives products a silky, dry-touch feel and is often used as a less-greasy alternative to heavier oils in cosmetic formulations.",
    whyClogsPores:
      "Ethylhexyl palmitate is one of the most commonly comedogenic esters in cosmetics. Its branched molecular structure lets it slip into follicles where it forms a plug that blocks sebum flow. It's rated moderately to highly comedogenic and is found in an enormous number of everyday skincare and makeup products.",
    commonProducts: ["foundations", "sunscreens", "moisturizers", "primers", "BB creams"],
    alsoKnownAs: ["Octyl Palmitate", "2-Ethylhexyl Palmitate"],
  },
  {
    name: "Isocetyl Stearate",
    slug: "isocetyl-stearate",
    category: "Ester",
    description:
      "A synthetic ester of isocetyl alcohol and stearic acid, used as an emollient and skin-conditioning agent.",
    whyUsed:
      "It provides a rich, moisturizing feel without heaviness and helps improve the texture and spreadability of formulations.",
    whyClogsPores:
      "Isocetyl stearate creates a lipid film within the follicle that prevents sebum from draining naturally. Its moderately large molecular structure allows it to accumulate in pore openings over time. Dermatological testing consistently rates it as comedogenic.",
    commonProducts: ["moisturizers", "foundations", "body lotions", "sunscreens"],
    alsoKnownAs: [],
  },
  {
    name: "Isodecyl Oleate",
    slug: "isodecyl-oleate",
    category: "Ester",
    description:
      "A synthetic ester of isodecyl alcohol and oleic acid, designed to deliver a smooth, emollient skin feel.",
    whyUsed:
      "It functions as a lightweight emollient and solvent that helps active ingredients penetrate the skin more effectively.",
    whyClogsPores:
      "The oleic acid portion of this ester is a proven pore irritant that disrupts the follicular lining and promotes comedone formation. Its penetration-enhancing properties actually help it deliver this pore-disrupting oleic acid deeper into follicles. This makes it a particularly effective pore-clogger despite its light feel.",
    commonProducts: ["moisturizers", "serums", "foundations", "body lotions"],
    alsoKnownAs: [],
  },
  {
    name: "Isopropyl Isosterate",
    slug: "isopropyl-isosterate",
    category: "Ester",
    description:
      "A synthetic ester of isopropyl alcohol and isostearic acid, used as a light emollient in cosmetics.",
    whyUsed:
      "It provides excellent spreadability and a silky skin feel, making it popular in lightweight formulations.",
    whyClogsPores:
      "Isopropyl isostearate is rated highly comedogenic in rabbit ear testing. Its branched-chain structure allows it to penetrate and accumulate inside pore openings, forming lipid plugs. Despite feeling light on the skin, it's one of the more reliably pore-clogging esters in cosmetic chemistry.",
    commonProducts: ["foundations", "moisturizers", "sunscreens", "primers"],
    alsoKnownAs: [],
  },
  {
    name: "Isopropyl Linolate",
    slug: "isopropyl-linolate",
    category: "Ester",
    description:
      "A synthetic ester of isopropyl alcohol and linoleic acid, offering a light, non-greasy emollient effect.",
    whyUsed:
      "It's used as a skin-conditioning agent and penetration enhancer that helps other active ingredients absorb more readily.",
    whyClogsPores:
      "Isopropyl linolate forms a thin lipid film inside pores that impedes natural sebum flow. Its penetration-enhancing properties mean it can deliver pore-irritating compounds deeper into follicles. Combined with its own comedogenic tendency, this makes it a dual threat for acne-prone skin.",
    commonProducts: ["moisturizers", "body lotions", "serums"],
    alsoKnownAs: [],
  },
  {
    name: "Isopropyl Linoleate",
    slug: "isopropyl-linoleate",
    category: "Ester",
    description:
      "A synthetic ester closely related to isopropyl linolate, combining isopropyl alcohol with linoleic acid for emollient and conditioning properties.",
    whyUsed:
      "It acts as a lightweight skin conditioner and helps improve the texture of lotions and creams.",
    whyClogsPores:
      "Like its cousin isopropyl linolate, this ester deposits a lipid layer inside follicles that blocks sebum drainage. It also enhances the penetration of other comedogenic ingredients in a formula. Dermatological studies rate it as a moderate comedogenic risk.",
    commonProducts: ["moisturizers", "body lotions", "hair products"],
    alsoKnownAs: [],
  },
  {
    name: "Isopropyl Myristate",
    slug: "isopropyl-myristate",
    category: "Ester",
    description:
      "One of the most widely used synthetic esters in cosmetics, formed from isopropyl alcohol and myristic acid. It's a staple emollient and penetration enhancer.",
    whyUsed:
      "Formulators use it constantly because it reduces greasiness, improves spreadability, and helps active ingredients absorb into the skin faster.",
    whyClogsPores:
      "Isopropyl myristate is one of the most well-documented comedogenic ingredients, scoring a 5 out of 5 in many comedogenicity studies. Its small molecular size lets it penetrate deep into pores where it creates persistent lipid plugs. It's actually used as the positive control in comedogenicity testing — meaning it's the benchmark other pore-cloggers are compared against.",
    commonProducts: ["foundations", "lotions", "sunscreens", "antiperspirants", "hair products"],
    alsoKnownAs: ["IPM"],
  },
  {
    name: "Isopropyl Palmitate",
    slug: "isopropyl-palmitate",
    category: "Ester",
    description:
      "A synthetic ester of isopropyl alcohol and palmitic acid, one of the most common emollients in the cosmetics industry.",
    whyUsed:
      "It provides a non-greasy, silky feel and is widely used to improve product texture and help active ingredients penetrate.",
    whyClogsPores:
      "Isopropyl palmitate is highly comedogenic, scoring 4 out of 5 in standard testing. Like isopropyl myristate, its small molecular structure lets it penetrate into pores and form stubborn lipid plugs. It's found in a staggering number of skincare and makeup products, making it one of the most common hidden acne triggers.",
    commonProducts: ["moisturizers", "foundations", "sunscreens", "body lotions", "lip products"],
    alsoKnownAs: ["IPP"],
  },
  {
    name: "Isostearyl Isostearate",
    slug: "isostearyl-isostearate",
    category: "Ester",
    description:
      "A synthetic diester made from isostearyl alcohol and isostearic acid, providing a rich emollient effect.",
    whyUsed:
      "It creates a luxurious, moisturizing feel in products and helps form stable emulsions with a smooth texture.",
    whyClogsPores:
      "Isostearyl isostearate has a large, branched molecular structure that forms a persistent occlusive film over pores. This film traps sebum and dead skin cells, creating the perfect environment for comedones to develop. Its heavy emollient properties make it especially problematic for oily and acne-prone skin types.",
    commonProducts: ["foundations", "moisturizers", "lipsticks", "concealers"],
    alsoKnownAs: [],
  },
  {
    name: "Isostearyl Neopentanoate",
    slug: "isostearyl-neopentanoate",
    category: "Ester",
    description:
      "A synthetic ester of isostearyl alcohol and neopentanoic acid, prized for its exceptionally light and non-greasy skin feel.",
    whyUsed:
      "It's a popular emollient in color cosmetics because it provides great spreadability and a dry, powdery finish.",
    whyClogsPores:
      "Despite its light feel, isostearyl neopentanoate deposits a lipid residue inside pores that blocks sebum drainage. Its branched-chain structure helps it accumulate in the follicular opening over time. It's frequently found in makeup products where prolonged wear means prolonged pore exposure.",
    commonProducts: ["foundations", "primers", "concealer", "BB creams", "lip products"],
    alsoKnownAs: [],
  },
  {
    name: "Myristyl Lactate",
    slug: "myristyl-lactate",
    category: "Ester",
    description:
      "An ester of myristyl alcohol and lactic acid, combining moisturizing and mild exfoliating properties.",
    whyUsed:
      "It acts as an emollient that also provides gentle exfoliation from the lactic acid component, popular in smoothing formulations.",
    whyClogsPores:
      "Myristyl lactate is rated as highly comedogenic in dermatological testing. Its myristyl chain penetrates into pore openings and forms lipid plugs, while the lactic acid portion can irritate the follicular lining. This combination of physical blockage and chemical irritation makes it especially acnegenic.",
    commonProducts: ["moisturizers", "body lotions", "exfoliating creams"],
    alsoKnownAs: [],
  },
  {
    name: "Myristyl Myristate",
    slug: "myristyl-myristate",
    category: "Ester",
    description:
      "A waxy ester formed from myristyl alcohol and myristic acid, providing a rich, cushiony emollient effect.",
    whyUsed:
      "It gives products a thick, luxurious texture and excellent moisturization, often used in rich creams and balms.",
    whyClogsPores:
      "Myristyl myristate is highly comedogenic due to its heavy, waxy molecular structure that sits on the skin and seals pore openings. Both the myristyl alcohol and myristic acid components are individually comedogenic, and their combination amplifies the pore-clogging effect. It's one of the heavier esters and is very slow to absorb.",
    commonProducts: ["rich creams", "balms", "body butters", "foundations"],
    alsoKnownAs: [],
  },
  {
    name: "Octyl Palmitate",
    slug: "octyl-palmitate",
    category: "Ester",
    description:
      "A synthetic ester of 2-ethylhexanol and palmitic acid, functionally identical to ethylhexyl palmitate.",
    whyUsed:
      "It provides a silky, non-greasy emollient effect and is widely used to improve the feel and spreadability of cosmetic products.",
    whyClogsPores:
      "Octyl palmitate is moderately to highly comedogenic, depositing a lipid film inside follicles that blocks sebum from draining. Its branched molecular structure helps it penetrate into pore openings where it forms persistent plugs. It's one of the most widespread comedogenic esters in everyday skincare and makeup.",
    commonProducts: ["foundations", "sunscreens", "moisturizers", "primers"],
    alsoKnownAs: ["Ethylhexyl Palmitate", "2-Ethylhexyl Palmitate"],
  },
  {
    name: "Octyl Stearate",
    slug: "octyl-stearate",
    category: "Ester",
    description:
      "A synthetic ester of 2-ethylhexanol and stearic acid, used as an emollient and viscosity-controlling agent.",
    whyUsed:
      "It provides a smooth, moisturizing feel without greasiness and helps control the thickness of liquid formulations.",
    whyClogsPores:
      "Octyl stearate creates a lipid barrier over pore openings that traps sebum and dead cells inside the follicle. Its molecular size is ideal for lodging in the narrow opening of a pore. Over time, this accumulation leads to comedone formation, especially when worn for extended periods in makeup.",
    commonProducts: ["foundations", "moisturizers", "sunscreens", "body lotions"],
    alsoKnownAs: ["Ethylhexyl Stearate", "2-Ethylhexyl Stearate"],
  },
  {
    name: "Stearyl Heptanoate",
    slug: "stearyl-heptanoate",
    category: "Ester",
    description:
      "A synthetic ester of stearyl alcohol and heptanoic acid, used as a lightweight emollient and skin-conditioning agent.",
    whyUsed:
      "It provides a dry, silky feel on the skin and is used to improve the sensory profile of lotions and creams.",
    whyClogsPores:
      "Stearyl heptanoate's long-chain stearyl group creates a persistent film over pore openings that resists normal skin cleansing. This film traps sebum and promotes comedone buildup. Its comedogenic potential is moderate to high, making it a concern in leave-on products for acne-prone skin.",
    commonProducts: ["moisturizers", "body lotions", "foundations"],
    alsoKnownAs: [],
  },

  // ─── Fatty Acids & Alcohols ───
  {
    name: "Isocetyl Alcohol",
    slug: "isocetyl-alcohol",
    category: "Fatty Acid & Alcohol",
    description:
      "A branched-chain fatty alcohol derived from cetyl alcohol, used as an emollient and emulsion stabilizer.",
    whyUsed:
      "It provides moisturization and helps thicken and stabilize emulsions without the waxy feel of straight-chain fatty alcohols.",
    whyClogsPores:
      "Isocetyl alcohol has a moderately comedogenic rating due to its ability to form an occlusive film over pore openings. Its branched-chain structure makes it harder for the skin to break down, so it accumulates in and around follicles. This leads to gradual pore congestion over time.",
    commonProducts: ["moisturizers", "foundations", "lotions", "sunscreens"],
    alsoKnownAs: ["Isohexadecanol"],
  },
  {
    name: "Lauric Acid",
    slug: "lauric-acid",
    category: "Fatty Acid & Alcohol",
    description:
      "A 12-carbon saturated fatty acid naturally found in coconut oil, palm kernel oil, and breast milk.",
    whyUsed:
      "It has antimicrobial properties and is used as an emulsifier, surfactant, and the building block for many cosmetic ingredients.",
    whyClogsPores:
      "Lauric acid is one of the key reasons coconut oil is so comedogenic. It's a solid fatty acid at skin temperature that can crystallize inside pores and form stubborn plugs. While it does have antibacterial properties, its pore-clogging action typically outweighs any antimicrobial benefit for acne-prone skin.",
    commonProducts: ["cleansers", "soaps", "moisturizers", "shampoos"],
    alsoKnownAs: ["Dodecanoic Acid"],
  },
  {
    name: "Lauryl Alcohol",
    slug: "lauryl-alcohol",
    category: "Fatty Acid & Alcohol",
    description:
      "A 12-carbon straight-chain fatty alcohol, a waxy solid used as an emollient, emulsifier, and thickening agent.",
    whyUsed:
      "It helps emulsify and thicken formulations while providing mild skin conditioning and a smooth texture.",
    whyClogsPores:
      "Lauryl alcohol has a waxy consistency that forms a pore-sealing film on the skin surface. Its relatively small molecular size allows it to penetrate into follicular openings where it solidifies and blocks sebum flow. It's moderately comedogenic and is often a hidden contributor to breakouts.",
    commonProducts: ["moisturizers", "cleansers", "hair products"],
    alsoKnownAs: ["Dodecanol", "1-Dodecanol"],
  },
  {
    name: "Myristic Acid",
    slug: "myristic-acid",
    category: "Fatty Acid & Alcohol",
    description:
      "A 14-carbon saturated fatty acid found abundantly in coconut oil, palm kernel oil, and nutmeg butter.",
    whyUsed:
      "It's used as a cleansing agent in soaps and facial washes, and as an emollient and opacifying agent in creams.",
    whyClogsPores:
      "Myristic acid is one of the most comedogenic fatty acids, scoring high in comedogenicity testing. It solidifies inside pores and creates waxy plugs that block sebum drainage. It's a primary reason why many coconut-derived ingredients are problematic for acne-prone skin.",
    commonProducts: ["facial cleansers", "soaps", "shaving creams", "moisturizers"],
    alsoKnownAs: ["Tetradecanoic Acid"],
  },
  {
    name: "Oleyl Alcohol",
    slug: "oleyl-alcohol",
    category: "Fatty Acid & Alcohol",
    description:
      "An unsaturated fatty alcohol derived from oleic acid, found naturally in fish oil and various plant sources.",
    whyUsed:
      "It's an effective emollient and emulsifier that also acts as a penetration enhancer, helping other ingredients absorb into skin.",
    whyClogsPores:
      "Oleyl alcohol is highly comedogenic, combining the pore-irritating properties of oleic acid derivatives with occlusive film-forming ability. It penetrates into the follicular lining and disrupts the lipid balance, promoting comedone formation. Its penetration-enhancing properties also drag other irritants deeper into pores.",
    commonProducts: ["moisturizers", "hair conditioners", "lotions", "pharmaceutical creams"],
    alsoKnownAs: ["Ocenol", "Cis-9-Octadecen-1-ol"],
  },
  {
    name: "Stearic Acid TEA",
    slug: "stearic-acid-tea",
    category: "Fatty Acid & Alcohol",
    description:
      "A combination of stearic acid (an 18-carbon saturated fatty acid) with triethanolamine (TEA), which forms a soap-like emulsifier in situ.",
    whyUsed:
      "When stearic acid and TEA combine in a formula, they create a self-emulsifying base that produces stable, creamy lotions without additional emulsifiers.",
    whyClogsPores:
      "The stearic acid component forms a waxy, occlusive layer over pores that traps sebum and dead cells. When combined with TEA, the resulting soap-like compound can also irritate the follicular lining. This dual action of occlusion and irritation makes it problematic for acne-prone skin.",
    commonProducts: ["lotions", "creams", "shaving creams", "foundations"],
    alsoKnownAs: ["Stearic Acid / Triethanolamine"],
  },

  // ─── Emulsifiers ───
  {
    name: "Cetearyl Alcohol & Ceteareth 20",
    slug: "cetearyl-alcohol-and-ceteareth-20",
    category: "Emulsifier",
    description:
      "A common emulsifying wax system combining cetearyl alcohol (a fatty alcohol) with ceteareth-20 (a polyethylene glycol ether) to create stable oil-in-water emulsions.",
    whyUsed:
      "It's one of the most widely used emulsifier systems in cosmetics because it creates stable, elegant creams and lotions with minimal formulation effort.",
    whyClogsPores:
      "This emulsifying system leaves a waxy residue on the skin that can block pore openings. The cetearyl alcohol component forms an occlusive film, while the ceteareth-20 helps deposit this film uniformly across the skin surface. Together they create a smooth but pore-sealing layer, especially problematic in heavy creams.",
    commonProducts: ["moisturizers", "lotions", "conditioners", "body creams"],
    alsoKnownAs: ["Emulsifying Wax NF", "Cetearyl Alcohol/Ceteareth-20"],
  },
  {
    name: "Glyceryl Stearate SE",
    slug: "glyceryl-stearate-se",
    category: "Emulsifier",
    description:
      "A self-emulsifying (SE) form of glyceryl stearate that contains a small amount of sodium or potassium stearate to improve its emulsifying ability.",
    whyUsed:
      "It's an easy-to-use emulsifier that creates stable, creamy formulations and doubles as an emollient and skin-conditioning agent.",
    whyClogsPores:
      "Glyceryl stearate SE forms a lipid film on skin that can occlude pore openings and trap sebum. The self-emulsifying component helps this film adhere more uniformly to the skin surface, making it harder to wash off. It rates as moderately comedogenic in dermatological testing.",
    commonProducts: ["moisturizers", "lotions", "sunscreens", "foundations"],
    alsoKnownAs: ["Glyceryl Monostearate SE"],
  },
  {
    name: "Glyceryl 3-Diisostearate",
    slug: "glyceryl-3-diisostearate",
    category: "Emulsifier",
    description:
      "A lipophilic emulsifier made from glycerin and two isostearic acid chains, used to create water-in-oil emulsions.",
    whyUsed:
      "It produces rich, stable water-in-oil creams and is valued for its strong emollient properties and moisture-locking ability.",
    whyClogsPores:
      "Glyceryl 3-Diisostearate is highly comedogenic due to its heavy, lipid-rich molecular structure. It forms a thick occlusive layer that seals pores and prevents sebum from draining. The isostearic acid chains are particularly problematic because they resist breakdown and persist on the skin surface.",
    commonProducts: ["rich creams", "foundations", "concealers", "eye creams"],
    alsoKnownAs: ["Glyceryl Diisostearate"],
  },
  {
    name: "Polyglyceryl-3 Diisostearate",
    slug: "polyglyceryl-3-diisostearate",
    category: "Emulsifier",
    description:
      "A polyglycerol ester made from polyglycerin-3 and isostearic acid, used as a water-in-oil emulsifier.",
    whyUsed:
      "It creates stable, rich emulsions and is popular in makeup formulations for its pigment-wetting and suspending abilities.",
    whyClogsPores:
      "This emulsifier deposits a heavy lipid layer on the skin that blocks pore openings and prevents normal sebum drainage. Its isostearic acid chains form a persistent film that resists cleansing. It rates as highly comedogenic and is especially problematic in foundation and concealer formulations worn for extended hours.",
    commonProducts: ["foundations", "concealers", "BB creams", "tinted moisturizers"],
    alsoKnownAs: [],
  },
  {
    name: "PG Monostearate",
    slug: "pg-monostearate",
    category: "Emulsifier",
    description:
      "An ester of propylene glycol and stearic acid, functioning as an emulsifier and skin-conditioning agent.",
    whyUsed:
      "It helps oil and water phases blend smoothly and contributes a creamy, moisturizing feel to lotions and creams.",
    whyClogsPores:
      "PG monostearate forms a stearic acid-based film on skin that occludes pore openings. The propylene glycol component enhances the penetration of this film into the follicular opening. This means it doesn't just sit on top of pores — it actively gets pushed inside them, worsening the comedogenic effect.",
    commonProducts: ["moisturizers", "lotions", "creams", "sunscreens"],
    alsoKnownAs: ["Propylene Glycol Stearate"],
  },
  {
    name: "Propylene Glycol Monostearate",
    slug: "propylene-glycol-monostearate",
    category: "Emulsifier",
    description:
      "An ester of propylene glycol and stearic acid, closely related to PG Monostearate, used as an emulsifier and emollient.",
    whyUsed:
      "It creates stable emulsions and provides a smooth, moisturizing skin feel in lotions and creams.",
    whyClogsPores:
      "This ingredient creates a stearic acid-based occlusive layer over pores while the propylene glycol moiety helps it penetrate into follicular openings. The result is a comedogenic film that's both on top of and inside the pore. It has a moderate comedogenic rating in dermatological testing.",
    commonProducts: ["moisturizers", "lotions", "creams", "body washes"],
    alsoKnownAs: ["PGMS"],
  },
  {
    name: "Sorbitan Oleate",
    slug: "sorbitan-oleate",
    category: "Emulsifier",
    description:
      "A nonionic emulsifier made from sorbitol and oleic acid, used to create water-in-oil emulsions.",
    whyUsed:
      "It's a versatile emulsifier that helps create stable, rich formulations and is compatible with a wide range of other ingredients.",
    whyClogsPores:
      "Sorbitan oleate's oleic acid component disrupts the lipid balance inside pores, making it inherently comedogenic. The emulsifier creates a sticky film on skin that traps sebum and bacteria in follicles. It's particularly problematic because it's often used alongside other comedogenic ingredients, compounding the pore-clogging effect.",
    commonProducts: ["creams", "lotions", "ointments", "makeup"],
    alsoKnownAs: ["Span 80"],
  },

  // ─── Ether, PEG & PPG ───
  {
    name: "Laureth-4",
    slug: "laureth-4",
    category: "Ether, PEG & PPG",
    description:
      "A polyethylene glycol ether of lauryl alcohol with 4 moles of ethylene oxide, used as a surfactant and emulsifier.",
    whyUsed:
      "It helps oil and water mix in formulations and provides mild cleansing action in wash-off and leave-on products.",
    whyClogsPores:
      "Laureth-4 has a low ethoxylation level that makes it more lipophilic and prone to leaving a residue in pores. This residue blocks sebum flow and creates comedones. Its relatively small molecular size lets it penetrate into the follicular opening, where it's difficult to rinse away.",
    commonProducts: ["cleansers", "lotions", "bath products", "hair products"],
    alsoKnownAs: [],
  },
  {
    name: "Laureth-23",
    slug: "laureth-23",
    category: "Ether, PEG & PPG",
    description:
      "A polyethylene glycol ether of lauryl alcohol with 23 moles of ethylene oxide, functioning as a solubilizer and emulsifier.",
    whyUsed:
      "It helps dissolve and incorporate oils into water-based formulations, acting as a more water-soluble emulsifier.",
    whyClogsPores:
      "Despite its higher ethoxylation making it more water-soluble than Laureth-4, Laureth-23 can still deposit a pore-blocking film when left on skin. It helps solubilize oils in a way that can deposit them into follicular openings. Its comedogenic risk is moderate but real for acne-prone skin.",
    commonProducts: ["moisturizers", "cleansers", "serums", "hair products"],
    alsoKnownAs: [],
  },
  {
    name: "Myreth 3 Myristate",
    slug: "myreth-3-myristate",
    category: "Ether, PEG & PPG",
    description:
      "A polyethylene glycol ether ester combining myristyl alcohol, 3 moles of ethylene oxide, and myristic acid.",
    whyUsed:
      "It functions as a lightweight emollient with emulsifying properties, giving products a smooth, non-greasy feel.",
    whyClogsPores:
      "The myristic acid component of this ester is inherently comedogenic, and the ethoxylated structure helps it adhere to skin and penetrate into pore openings. It forms a lipid film inside follicles that blocks sebum drainage. The combination of comedogenic fatty acid and skin-adhering ether makes this a potent pore-clogger.",
    commonProducts: ["moisturizers", "body lotions", "foundations"],
    alsoKnownAs: [],
  },
  {
    name: "Oleth-3",
    slug: "oleth-3",
    category: "Ether, PEG & PPG",
    description:
      "A polyethylene glycol ether of oleyl alcohol with 3 moles of ethylene oxide, a low-HLB emulsifier and emollient.",
    whyUsed:
      "It serves as a lipophilic emulsifier that helps create rich, moisturizing water-in-oil formulations.",
    whyClogsPores:
      "Oleth-3 combines the comedogenic properties of oleyl alcohol with a low ethoxylation level that keeps it lipophilic and pore-penetrating. It disrupts the follicular lipid barrier and deposits an oleic acid-derived residue inside pores. This leads to comedone formation, especially with prolonged skin contact.",
    commonProducts: ["creams", "lotions", "body butters", "hair products"],
    alsoKnownAs: [],
  },
  {
    name: "Oleth-5",
    slug: "oleth-5",
    category: "Ether, PEG & PPG",
    description:
      "A polyethylene glycol ether of oleyl alcohol with 5 moles of ethylene oxide, slightly more water-soluble than Oleth-3.",
    whyUsed:
      "It's used as an emulsifier and solubilizer that helps incorporate oils into lighter formulations.",
    whyClogsPores:
      "Like Oleth-3, this ingredient carries the comedogenic legacy of oleyl alcohol. Its ethoxylated structure helps it deposit an oleic acid-derived film on and inside pore openings. Even at a slightly higher ethoxylation level, it retains enough lipophilicity to clog pores in acne-prone skin.",
    commonProducts: ["moisturizers", "lotions", "cleansers"],
    alsoKnownAs: [],
  },
  {
    name: "PEG 200 Dilaurate",
    slug: "peg-200-dilaurate",
    category: "Ether, PEG & PPG",
    description:
      "A polyethylene glycol diester of lauric acid with 200 moles of ethylene oxide, used as an emulsifier and skin-conditioning agent.",
    whyUsed:
      "It helps create stable emulsions and adds a smooth, conditioned feel to both rinse-off and leave-on products.",
    whyClogsPores:
      "PEG 200 Dilaurate deposits lauric acid-derived residues on the skin that can block pore openings. Despite its high ethoxylation, the dual lauric acid chains give it enough lipophilic character to create a comedogenic film. Acne-prone skin may react to the lauric acid components with increased comedone formation.",
    commonProducts: ["moisturizers", "body washes", "hair products", "cleansers"],
    alsoKnownAs: [],
  },
  {
    name: "PPG 2 Myristyl Propionate",
    slug: "ppg-2-myristyl-propionate",
    category: "Ether, PEG & PPG",
    description:
      "A polypropylene glycol ether ester of myristyl alcohol and propionic acid, used as a lightweight emollient.",
    whyUsed:
      "It provides a silky, non-greasy emollient effect and is used to improve the sensory profile of skincare and makeup products.",
    whyClogsPores:
      "The myristyl alcohol component is comedogenic on its own, and the PPG ether structure helps it adhere to and penetrate into pore openings. It deposits a thin but persistent lipid film inside follicles that impedes sebum flow. It's rated as comedogenic in dermatological testing.",
    commonProducts: ["foundations", "moisturizers", "primers", "body lotions"],
    alsoKnownAs: [],
  },
  {
    name: "PPG 6 Ceteth 10 Phosphate",
    slug: "ppg-6-ceteth-10-phosphate",
    category: "Ether, PEG & PPG",
    description:
      "A complex phosphate ester combining polypropylene glycol, cetyl alcohol, and polyethylene glycol, used as an emulsifier.",
    whyUsed:
      "It's a specialty emulsifier used in advanced formulations that require stable oil-in-water or water-in-oil emulsions.",
    whyClogsPores:
      "This complex emulsifier leaves a residue on skin that includes cetyl alcohol-derived compounds known to block pores. Its phosphate ester structure helps it adhere strongly to skin, making the pore-blocking film difficult to remove. It's a lesser-known but real comedogenic risk in specialty formulations.",
    commonProducts: ["advanced creams", "serums", "specialty moisturizers"],
    alsoKnownAs: [],
  },
  {
    name: "PPG 10 Cetyl Ether",
    slug: "ppg-10-cetyl-ether",
    category: "Ether, PEG & PPG",
    description:
      "A polypropylene glycol ether of cetyl alcohol with 10 moles of propylene oxide, used as an emollient and solvent.",
    whyUsed:
      "It provides a smooth, silky feel and helps dissolve other ingredients, improving the overall texture of formulations.",
    whyClogsPores:
      "PPG 10 Cetyl Ether deposits a cetyl alcohol-based residue on skin that creates an occlusive film over pores. The polypropylene glycol chain helps this residue spread and adhere uniformly. This ingredient is moderately comedogenic and can contribute to pore congestion in leave-on products.",
    commonProducts: ["moisturizers", "serums", "foundations", "lotions"],
    alsoKnownAs: [],
  },
  {
    name: "Steareth 10",
    slug: "steareth-10",
    category: "Ether, PEG & PPG",
    description:
      "A polyethylene glycol ether of stearyl alcohol with 10 moles of ethylene oxide, used as a nonionic emulsifier and solubilizer.",
    whyUsed:
      "It helps create stable oil-in-water emulsions and improves the compatibility of oil-soluble ingredients in water-based formulations.",
    whyClogsPores:
      "Steareth 10 deposits stearyl alcohol-derived residues on skin that form an occlusive film over pore openings. Its moderate ethoxylation still leaves it lipophilic enough to penetrate into follicles. The stearic acid chain component creates a waxy layer that traps sebum and promotes comedones.",
    commonProducts: ["moisturizers", "lotions", "creams", "hair products"],
    alsoKnownAs: [],
  },

  // ─── Surfactants ───
  {
    name: "Disodium Monooleamido PEG 2-Sulfosuccinate",
    slug: "disodium-monooleamido-peg-2-sulfosuccinate",
    category: "Surfactant",
    description:
      "A mild anionic surfactant derived from oleic acid and sulfosuccinic acid, designed as a gentler cleansing agent.",
    whyUsed:
      "It provides foaming and cleansing without being as harsh as traditional sulfates, making it popular in \"gentle\" and \"sensitive skin\" formulations.",
    whyClogsPores:
      "This surfactant's oleic acid-derived portion can deposit a pore-blocking residue on skin, especially in rinse-off products that aren't thoroughly washed away. The residue disrupts the follicular lipid barrier and traps sebum inside. It's a surprising pore-clogger for a product marketed as gentle.",
    commonProducts: ["cleansers", "shampoos", "body washes", "baby products"],
    alsoKnownAs: [],
  },
  {
    name: "Sodium Laureth Sulfate",
    slug: "sodium-laureth-sulfate",
    category: "Surfactant",
    description:
      "An ethoxylated version of sodium lauryl sulfate, a widely used anionic surfactant that creates rich lather and effectively removes oil and dirt.",
    whyUsed:
      "It's one of the most popular cleansing agents in the world — cheap, effective, and produces the satisfying foam consumers expect from cleansers and shampoos.",
    whyClogsPores:
      "SLES strips the skin of its protective lipid barrier, which triggers a rebound overproduction of sebum that can flood and clog pores. It also irritates the follicular wall, making it more prone to trapping dead cells and forming comedones. The irritation-then-overproduction cycle is especially damaging for acne-prone skin.",
    commonProducts: ["shampoos", "body washes", "facial cleansers", "toothpaste"],
    alsoKnownAs: ["SLES", "Sodium Lauryl Ether Sulfate"],
  },
  {
    name: "Sodium Lauryl Sulfate",
    slug: "sodium-lauryl-sulfate",
    category: "Surfactant",
    description:
      "A powerful anionic surfactant derived from lauryl alcohol, known for its strong degreasing and foaming properties.",
    whyUsed:
      "It's cheap, extremely effective at cutting grease, and creates thick, rich foam — making it a workhorse in cleansing products worldwide.",
    whyClogsPores:
      "SLS is one of the most irritating common surfactants, aggressively stripping the skin barrier and causing reactive sebum overproduction. This excess oil floods pores and combines with dead cells to form comedones. SLS also directly irritates the follicular epithelium, increasing the likelihood of inflammatory acne lesions.",
    commonProducts: ["shampoos", "facial cleansers", "body washes", "toothpaste", "dish soap"],
    alsoKnownAs: ["SLS", "Sodium Dodecyl Sulfate"],
  },

  // ─── Mineral & Petrochemical ───
  {
    name: "Bismuth Oxychloride",
    slug: "bismuth-oxychloride",
    category: "Mineral & Petrochemical",
    description:
      "A synthetic mineral compound that creates a pearlescent, shimmery finish in cosmetics, with a crystal structure similar to talc.",
    whyUsed:
      "It gives mineral makeup its silky, luminous appearance and smooth application — it's the reason mineral foundation has that signature glow.",
    whyClogsPores:
      "Bismuth oxychloride has a flat, plate-like crystal structure that lies flat over pore openings and physically blocks them. It's also an irritant that causes itching and inflammation in many users, which worsens breakouts. The particles are nearly impossible to fully remove from pores with regular cleansing.",
    commonProducts: ["mineral foundations", "eyeshadows", "blushes", "pressed powders"],
    alsoKnownAs: ["CI 77163"],
  },
  {
    name: "Coal Tar",
    slug: "coal-tar",
    category: "Mineral & Petrochemical",
    description:
      "A thick, dark liquid produced by the destructive distillation of coal, containing thousands of compounds including polycyclic aromatic hydrocarbons.",
    whyUsed:
      "It has anti-inflammatory, anti-itch, and anti-scaling properties that make it effective in treating psoriasis, eczema, and dandruff.",
    whyClogsPores:
      "Coal tar is extremely heavy and occlusive, creating a thick film that seals pores completely. Its complex mixture of hydrocarbons irritates follicular walls and promotes abnormal keratinization (excess dead cell production inside the pore). The result is both physical blockage and biological disruption of normal pore function.",
    commonProducts: ["dandruff shampoos", "psoriasis treatments", "scalp treatments"],
    alsoKnownAs: ["Pix Carbonis", "Crude Coal Tar"],
  },
  {
    name: "Colloidal Sulfur",
    slug: "colloidal-sulfur",
    category: "Mineral & Petrochemical",
    description:
      "Finely divided elemental sulfur particles suspended in a liquid medium, used in dermatological treatments.",
    whyUsed:
      "Sulfur has antibacterial and keratolytic properties that help treat acne, rosacea, and seborrheic dermatitis.",
    whyClogsPores:
      "Ironically, colloidal sulfur used to treat acne can actually worsen it for some people. The fine particles can physically accumulate in and around pore openings, forming plugs. In the colloidal form, these particles are especially prone to depositing inside follicles where they create blockages rather than clearing them.",
    commonProducts: ["acne treatments", "spot treatments", "medicated cleansers", "masks"],
    alsoKnownAs: ["Precipitated Sulfur", "Sulfur"],
  },
  {
    name: "Hydrogenated Vegetable Oil",
    slug: "hydrogenated-vegetable-oil",
    category: "Mineral & Petrochemical",
    description:
      "Vegetable oils that have been chemically treated with hydrogen to convert unsaturated fats to saturated ones, making them solid at room temperature.",
    whyUsed:
      "Hydrogenation gives oils a thicker, more stable consistency that's easier to formulate with and extends product shelf life.",
    whyClogsPores:
      "Hydrogenation converts the oils into saturated fats with a heavy, waxy consistency that forms a thick occlusive barrier over pores. The resulting solid fat is very difficult for skin to break down or absorb, so it sits on the surface and blocks sebum drainage. It's essentially turning a plant oil into something as pore-clogging as an animal fat.",
    commonProducts: ["moisturizers", "lip balms", "body butters", "creams"],
    alsoKnownAs: ["Vegetable Shortening", "Partially Hydrogenated Oil"],
  },
  {
    name: "Mineral Oil",
    slug: "mineral-oil",
    category: "Mineral & Petrochemical",
    description:
      "A colorless, odorless oil derived from petroleum, consisting of a mixture of hydrocarbons. One of the most widely used cosmetic ingredients in history.",
    whyUsed:
      "It's incredibly cheap, stable, and creates a powerful moisture barrier — making it a go-to for everything from baby oil to cold cream.",
    whyClogsPores:
      "Mineral oil creates an airtight occlusive seal over the skin that prevents any sebum from escaping pores. While cosmetic-grade mineral oil is more refined, it still forms a non-breathable layer that traps dead cells, bacteria, and oil inside follicles. For acne-prone skin, this is the definition of a pore-clogging nightmare.",
    commonProducts: ["baby oil", "moisturizers", "makeup removers", "petroleum jelly", "lotions"],
    alsoKnownAs: ["Paraffinum Liquidum", "Liquid Paraffin", "White Oil"],
  },
  {
    name: "Petroleum",
    slug: "petroleum",
    category: "Mineral & Petrochemical",
    description:
      "A semi-solid mixture of hydrocarbons derived from crude oil, most commonly known as petroleum jelly or petrolatum.",
    whyUsed:
      "It's one of the most effective occlusive moisturizers available, locking in virtually 100% of moisture and protecting damaged skin.",
    whyClogsPores:
      "Petroleum creates an impenetrable barrier over the skin that completely seals pore openings. Nothing gets in, but nothing gets out either — sebum, dead cells, and bacteria become trapped inside follicles. While dermatologists debate its comedogenicity, unrefined petroleum is undeniably pore-clogging for acne-prone skin.",
    commonProducts: ["petroleum jelly", "lip balms", "healing ointments", "moisturizers"],
    alsoKnownAs: ["Petrolatum", "Petroleum Jelly", "Vaseline"],
  },
  {
    name: "Potassium Chloride",
    slug: "potassium-chloride",
    category: "Mineral & Petrochemical",
    description:
      "A simple mineral salt (KCl) naturally found in seawater and salt deposits, used as a viscosity modifier in cosmetics.",
    whyUsed:
      "It thickens cleansing products and adjusts the consistency of formulations, especially shampoos and body washes.",
    whyClogsPores:
      "Potassium chloride's chloride ions can irritate the follicular lining when left in contact with skin, promoting inflammation and comedone formation. Salt residue can also dehydrate the pore lining, causing a reactive buildup of dead cells. While it's not occlusive like oils, its irritant mechanism makes it problematic for acne-prone skin.",
    commonProducts: ["shampoos", "body washes", "cleansers"],
    alsoKnownAs: ["Muriate of Potash", "KCl"],
  },
  {
    name: "Xylene",
    slug: "xylene",
    category: "Mineral & Petrochemical",
    description:
      "A petrochemical aromatic hydrocarbon solvent used in industrial applications and occasionally in cosmetics as a solvent.",
    whyUsed:
      "It's a powerful solvent that dissolves resins and other hard-to-dissolve ingredients in specialty formulations like nail polish.",
    whyClogsPores:
      "Xylene is a harsh chemical that strips the skin barrier and causes significant irritation to follicular walls. This damage triggers reactive hyperkeratinization (excess dead cell production) inside pores, leading to blockages. It also disrupts the lipid balance of the skin, making pores more vulnerable to clogging from other ingredients.",
    commonProducts: ["nail polish", "industrial products", "specialty coatings"],
    alsoKnownAs: ["Dimethylbenzene", "Xylol"],
  },

  // ─── Dye ───
  {
    name: "D&C Red #3, #17, #21, #30, #36",
    slug: "dc-red-3-17-21-30-36",
    category: "Dye",
    description:
      "A group of synthetic red dyes approved for use in drugs and cosmetics (D&C). Each number represents a different chemical compound with a red hue.",
    whyUsed:
      "These dyes provide vibrant red, pink, and coral colors to lipsticks, blushes, and other color cosmetics.",
    whyClogsPores:
      "D&C Red dyes are known comedogenic agents — they contain pigment particles that can lodge in pore openings and block sebum flow. Some of these dyes also cause contact irritation that inflames the follicular wall. Red dyes #17, #21, and #36 are especially problematic, scoring high on comedogenicity scales.",
    commonProducts: ["lipsticks", "blushes", "lip liners", "tinted moisturizers", "nail polish"],
    alsoKnownAs: ["CI 45430", "CI 26100", "CI 45380", "CI 73360", "CI 12085"],
  },

  // ─── Sulfated Oils ───
  {
    name: "Sulfated Castor Oil",
    slug: "sulfated-castor-oil",
    category: "Sulfated Oil",
    description:
      "Castor oil that has been treated with sulfuric acid, making it water-soluble. Also known as Turkey Red Oil, it was one of the first synthetic detergents.",
    whyUsed:
      "It acts as a surfactant, emulsifier, and solubilizer that helps disperse oils in water-based products, popular in bath oils and textile processing.",
    whyClogsPores:
      "Sulfated castor oil leaves an oily, surfactant-laden residue on skin that blocks pore openings. The sulfation process creates compounds that irritate the follicular lining, promoting inflammation and comedone formation. Its ability to deposit oil into aqueous environments means it can deliver pore-clogging lipids even from water-based products.",
    commonProducts: ["bath oils", "hair products", "cleansers", "body washes"],
    alsoKnownAs: ["Turkey Red Oil"],
  },
  {
    name: "Sulfated Jojoba Oil",
    slug: "sulfated-jojoba-oil",
    category: "Sulfated Oil",
    description:
      "Jojoba oil that has been treated with sulfuric acid to make it water-dispersible, while retaining some of jojoba's skin-conditioning properties.",
    whyUsed:
      "It combines jojoba's emollient benefits with water solubility, making it useful in aqueous formulations that want a jojoba marketing claim.",
    whyClogsPores:
      "Even though regular jojoba oil is relatively non-comedogenic, the sulfation process changes its molecular structure in ways that increase pore-clogging potential. The sulfated compound irritates the follicular lining and leaves a residue that blocks pore openings. The chemical modification essentially turns a skin-friendly oil into a comedogenic one.",
    commonProducts: ["shampoos", "body washes", "cleansers", "hair products"],
    alsoKnownAs: [],
  },

  // ─── Other ───
  {
    name: "Argania Spinosa",
    slug: "argania-spinosa",
    category: "Other",
    description:
      "The botanical name for the argan tree — when listed on ingredients, it typically refers to extracts from the tree other than the kernel oil (bark, leaf, or fruit extracts).",
    whyUsed:
      "It's used for its antioxidant and skin-conditioning properties, often alongside or in place of argan oil.",
    whyClogsPores:
      "Argania spinosa extracts carry many of the same oleic acid-rich compounds found in argan oil that disrupt follicular lipids. They can leave a comedogenic residue on the skin that traps sebum inside pores. When you see this Latin name, it's essentially a signal that argan-derived pore-clogging compounds are present.",
    commonProducts: ["serums", "moisturizers", "hair products"],
    alsoKnownAs: ["Argan Tree Extract"],
  },
  {
    name: "Coconut Alkanes",
    slug: "coconut-alkanes",
    category: "Other",
    description:
      "Saturated hydrocarbons derived from coconut oil through a hydrogenation and deoxygenation process, creating a lightweight emollient.",
    whyUsed:
      "They're marketed as a natural, plant-derived alternative to silicones, providing a silky, lightweight skin feel without synthetic ingredients.",
    whyClogsPores:
      "Despite being processed from coconut oil, coconut alkanes retain some of the pore-clogging potential of their source. Their hydrocarbon structure forms a film on skin similar to mineral oil, blocking pore openings. While lighter than coconut oil itself, they can still contribute to comedone formation in acne-prone skin.",
    commonProducts: ["primers", "foundations", "moisturizers", "serums", "clean beauty products"],
    alsoKnownAs: ["C13-15 Alkane"],
  },
  {
    name: "Cotton Awws",
    slug: "cotton-awws",
    category: "Other",
    description:
      "Fibers and extracts derived from the cotton plant, including fine cotton linters and cottonseed-derived compounds used in cosmetics.",
    whyUsed:
      "Cotton-derived ingredients provide a soft, absorbent quality to formulations and are marketed as gentle, natural skin conditioners.",
    whyClogsPores:
      "Cotton-derived compounds can leave fine fibrous residues on skin that physically block pore openings. Cottonseed-derived lipids in these ingredients have a comedogenic fatty acid profile similar to cottonseed oil. The combination of physical fiber particles and comedogenic lipids makes this a dual-action pore-clogger.",
    commonProducts: ["moisturizers", "cotton pads", "cleansers", "masks"],
    alsoKnownAs: [],
  },
  {
    name: "Crithmum Maritimum",
    slug: "crithmum-maritimum",
    category: "Other",
    description:
      "A coastal plant also known as sea fennel or rock samphire, used in skincare for its essential oil and stem cell extracts.",
    whyUsed:
      "It's trending in clean beauty for its vitamin C content, antioxidant properties, and skin-brightening stem cell technology.",
    whyClogsPores:
      "Crithmum Maritimum's essential oil is rich in terpenes and other compounds that can irritate the follicular lining and promote abnormal keratinization inside pores. The plant's waxy cuticle extracts also form an occlusive layer on skin. Products using concentrated sea fennel extract can trigger comedone formation in sensitive, acne-prone skin.",
    commonProducts: ["serums", "brightening treatments", "anti-aging creams", "eye creams"],
    alsoKnownAs: ["Sea Fennel", "Rock Samphire", "Samphire"],
  },
  {
    name: "Soil Minerals",
    slug: "soil-minerals",
    category: "Other",
    description:
      "A blend of minerals sourced from soil deposits, marketed as earth-derived skin nutrients in natural skincare.",
    whyUsed:
      "Brands use them for their mineral content and \"straight from the earth\" natural marketing appeal.",
    whyClogsPores:
      "Soil-derived mineral blends often contain heavy, unrefined particles that physically block pore openings. The variable composition of these blends makes it impossible to predict their comedogenic potential. They can also create an occlusive mineral layer on skin that traps sebum and dead cells inside follicles.",
    commonProducts: ["masks", "mineral treatments", "natural moisturizers"],
    alsoKnownAs: [],
  },
  {
    name: "Wheat Germ Glyceride",
    slug: "wheat-germ-glyceride",
    category: "Other",
    description:
      "A glycerol ester derived from wheat germ oil, providing the nutrients of wheat germ in a more formulation-friendly form.",
    whyUsed:
      "It delivers the vitamin E and fatty acid benefits of wheat germ oil with better emulsifying and texture properties.",
    whyClogsPores:
      "Wheat germ glyceride carries the same comedogenic fatty acid profile as wheat germ oil, including high oleic acid content. The glyceride form creates a persistent lipid film on skin that blocks pore openings. Like wheat germ oil, it's also prone to oxidation, and the oxidation byproducts further irritate follicular walls.",
    commonProducts: ["moisturizers", "anti-aging creams", "body lotions"],
    alsoKnownAs: ["Triticum Vulgare Germ Glyceride"],
  },
];

export function getIngredientBySlug(slug) {
  return ingredientData.find((i) => i.slug === slug);
}

export function getIngredientCategories() {
  return [...new Set(ingredientData.map((i) => i.category))].sort();
}
